import { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Upload, CheckCircle, AlertCircle, ChevronDown, ChevronRight, Download, Save, Trash2 } from "lucide-react";
import { apiConfig } from "../config/api.config";

/* ── Clasificación por fondo (CCPET||C.RES||FUENTE → fondo) ──────────────────
   Fuente: ProyeccionIngresos_2027.xlsx, octubre 2026.
   "ELIMINAR" = el rubro no se asigna a ningún fondo. */
const FONDO_MAP = {
  "1.1.01.01.014.01||11010101||12004": "ADMON",                // Sobretasa Ambiental - Urbano
  "1.1.01.01.014.01||11010108||12004": "ADMON",                // Vigencia Anterior Sobretasa Ambiental - Urbano
  "1.1.01.01.014.02||11010102||12004": "ADMON",                // Sobretasa Ambiental - Rural
  "1.1.01.01.014.02||11010109||12004": "ADMON",                // Vigencia Anterior Sobretasa Ambiental - Rural
  "1.1.01.01.200.01||11010104||11001": "ADMON",                // Impuesto Predial Unificado - Urbano
  "1.1.01.01.200.01||11010110||11001": "ADMON",                // Vigencia Anterior Impuesto Predial Unificado - Urbano
  "1.1.01.01.200.01||110101042||11001": "FLS",                 // Esfuerzo propio - FLS RS
  "1.1.01.01.200.01||110101043||11001": "FLS",                 // Esfuerzo propio - FLS SP
  "1.1.01.01.200.01||110101045||11001": "FLS",                 // Esfuerzo propio - FLS PS
  "1.1.01.01.200.01||110101046||11001": "FLS",                 // Esfuerzo propio - FLS OGS INV
  "1.1.01.01.200.02||11010105||11001": "ADMON",                // Predial unificado - Rural
  "1.1.01.01.200.02||11010111||11001": "ADMON",                // Vigencia Anterior Predial unificado - Rural
  "1.1.01.01.201||11010106||12005": "ADMON",                   // Sobretasa Area Metropolitana - Literal A - Urbano
  "1.1.01.01.201||11010107||12005": "ADMON",                   // Sobretasa Area Metropolitana - Literal D y G - Rural
  "1.1.01.01.201||11010112||12005": "ADMON",                   // Vigencia Anterior Sobretasa Area Metropolitana - Literal A - Urbano
  "1.1.01.01.201||11010113||12005": "ADMON",                   // Vigencia Anterior Sobretasa Area Metropolitana - Literal D y G - Rural
  "1.1.01.02.109||11010201||11001": "ADMON",                   // Sobretasa a la gasolina
  "1.1.01.02.109||11010227||11001": "ADMON",                   // Transferencia Sobretasa a la Gasolina ? Pignoraci?n Metro de Medell?n SSF
  "1.1.01.02.200.01||11010202||11001": "ADMON",                // Impuesto de Industria y comercio - sobre actividades comerciales
  "1.1.01.02.200.01||11010203||11001": "ADMON",                // Anticipo retencion industria y comercio - sobre actividades comerciales
  "1.1.01.02.200.01||11010220||11001": "ADMON",                // Vigencia Anterior Impuesto de Industria y comercio - sobre actividades comerciales
  "1.1.01.02.200.01||110102021||11001": "ADMON",               // Ingresos Corrientes - Fondo de Contingencias Judiciales
  "1.1.01.02.200.02||11010204||11001": "ADMON",                // Impuesto de industria y comercio - sobre actividades industriales
  "1.1.01.02.200.02||11010241||11001": "ADMON",                // Anticipo retencion industria y comercio - sobre actividades industriales
  "1.1.01.02.200.02||11010242||11001": "ADMON",                // Vigencia Anterior Impuesto de Industria y comercio - sobre actividades industriales
  "1.1.01.02.200.02||110102041||11001": "FONDO GESTION DEL RIESGO", // Impuesto de industria y comercio - sobre actividades industriales FGRED
  "1.1.01.02.200.03||11010205||11001": "ADMON",                // Impuesto de industria y comercio - sobre actividades de servicios
  "1.1.01.02.200.03||110102051||11001": "ADMON",               // Anticipo retencion industria y comercio - sobre actividades servicios
  "1.1.01.02.200.03||110102052||11001": "ADMON",               // Vigencia Anterior Impuesto de Industria y comercio - sobre actividades servicios
  "1.1.01.02.201||11010206||11001": "ADMON",                   // Avisos y tableros
  "1.1.01.02.201||11010223||11001": "ADMON",                   // Vigencia Anterior Avisos y tableros
  "1.1.01.02.202||11010207||11001": "ADMON",                   // Impuesto a la publicidad exterior visual
  "1.1.01.02.204||11010208||11001": "ADMON",                   // Impuesto de delineaci?n
  "1.1.01.02.209||11010209||11001": "ADMON",                   // Impuesto al deguello de ganado  menor
  "1.1.01.02.210||11010210||11001": "ADMON",                   // Impuesto de tel?fonos
  "1.1.01.02.211||11010211||12002": "ADMON",                   // Impuesto de alumbrado p?blico
  "1.1.01.02.211||11010212||12002": "ADMON",                   // Impuesto de alumbrado p?blico - Predial
  "1.1.01.02.211||11010225||12002": "ADMON",                   // Vigencia Anterior Impuesto de alumbrado p?blico - Predial
  "1.1.01.02.212||11010213||21007": "ADMON",                   // Sobretasa Bomberil
  "1.1.01.02.212||11010226||21007": "ADMON",                   // Vigencia Anterior  Sobretasa Bomberil
  "1.1.01.02.216||11010214||11001": "ADMON",                   // Impuesto de espect?culos p?blicos municipal
  "1.1.01.02.218||13010108||13006": "ADMON",                   // Tasa prodeporte y recreaci?n 1,5%
  "1.1.01.02.300.01||11010215||13001": "ADMON",                // Estampilla para el bienestar del adulto mayor
  "1.1.01.02.300.55||1130055||13004": "ADMON",                 // Estampilla Pro Cultura
  "1.1.01.02.300.61||13010107||13005": "ADMON",                // Estampilla para la justicia familiar 2%
  "1.1.02.01.005.59||11020101||21401": "FONSET",               // Contribuci?n especial sobre contratos de obras p?blicas
  "1.1.02.01.005.64.01||11020102||61001": "ADMON",             // Contribuci?n sector el?ctrico - Generadores de energ?a convencional -Proyecto porce II
  "1.1.02.01.005.72||11010218||12011": "ADMON",                // Impuesto por Obligaciones Urbanisticas - Espacio Publico
  "1.1.02.01.005.72||11010219||12011": "ADMON",                // Impuestos por Obligaciones Urbanisticas - Equipamiento
  "1.1.02.02.102||11020201||11001": "ADMON",                   // Licencias de conducci?n
  "1.1.02.02.102||11020202||11001": "ADMON",                   // Matr?culas de veh?culos
  "1.1.02.02.118||110205411||31402": "ADMON",                  // Incentivo al Aprovechamieno y Tratamiento de residuos solidos IAT
  "1.1.02.03.001.09||11020302||12003": "ADMON",                // Infracciones tr?nsito comparendos
  "1.1.02.03.001.09||11020303||11001": "ADMON",                // Otros del tr?nsito
  "1.1.02.03.001.11||11020304||11001": "ADMON",                // Sanciones Tributarias
  "1.1.02.03.001.20.01||11020305||12006": "FONSET",            // Multas c?digo nacional de polic?a y convivencia - Multas generales
  "1.1.02.03.001.20.01||110203051||12007": "ADMON",            // Multas ambientales
  "1.1.02.03.001.23||11020301||11001": "ADMON",                // Sanciones Urbanisticas
  "1.1.02.03.002||11020306||12004": "ADMON",                   // Intereses de mora sobretasa ambiental - corantioquia
  "1.1.02.03.002||11020307||11001": "ADMON",                   // Intereses de mora predial
  "1.1.02.03.002||11020308||12002": "ADMON",                   // Intereses Alumbrado Publico
  "1.1.02.03.002||11020309||11001": "ADMON",                   // Intereses de mora industria y comercio
  "1.1.02.03.002||11020310||11001": "ADMON",                   // Intereses de mora avisos y tableros
  "1.1.02.03.002||11020311||21007": "ADMON",                   // Intereses Sobretasa Bomberil
  "1.1.02.03.002||11020312||12005": "ADMON",                   // Intereses Sobretasa Area Metropolitana - Literal A - Urbano
  "1.1.02.03.002||11020313||12005": "ADMON",                   // Intereses Sobretasa Area Metropolitana - Literal D y G - Rural
  "1.1.02.03.002||11020314||12006": "FONSET",                  // Intereses Multas Codigo de Policia
  "1.1.02.03.002||11020316||11001": "ADMON",                   // Intereses de Mora Arrendamientos
  "1.1.02.03.002||11020318||11001": "ADMON",                   // Intereses de Mora - Ingresos Corrientes
  "1.1.02.03.002||13010106||11001": "ADMON",                   // INTERESES DE FINANCIACION
  "1.1.02.05.002.07||11020401||11001": "ADMON",                // Arrendamientos
  "1.1.02.05.002.09||11020403||11001": "ADMON",                // Usos del suelo
  "1.1.02.06.001.01.03.01||11020511||14001": "ADMON",          // SGP Educaci?n Calidad
  "1.1.02.06.001.01.03.02||11020512||14002": "ADMON",          // SGP Educacion Gratuidad SSF
  "1.1.02.06.001.02.01||11026101||23005": "FLS",               // S.G.P. Regimen Subsidiado Once Doceavas Continuidad SSF
  "1.1.02.06.001.02.01||11026102||23005": "FLS",               // S.G.P. Regimen Subsidiado Ultima Doceava Continuidad SSF
  "1.1.02.06.001.02.02||11026211||23101": "FLS",               // SGP Salud Publica Once doceava 60% - PLAN DE INTERVENCIONES COLECTIVAS (PIC)
  "1.1.02.06.001.02.02||11026212||23101": "FLS",               // SGP Salud Publica Ultima doceava 60% - PLAN DE INTERVENCIONES COLECTIVAS (PIC)
  "1.1.02.06.001.02.02||11026221||23101": "FLS",               // SGP Salud Publica Once doceavas 40% - GESTION EN SALUD PUBLICA
  "1.1.02.06.001.02.02||11026222||23101": "FLS",               // SGP Salud Publica Ultima doceava 40% - GESTION EN SALUD PUBLICA
  "1.1.02.06.001.02.04||11026301||23202": "FLS",               // SGP Subsidio a la oferta - Once Doceavas
  "1.1.02.06.001.02.04||11026302||23202": "FLS",               // SGP Subsidio a la oferta - Ultima Doceava
  "1.1.02.06.001.03.01||11020513||14301": "ADMON",             // SGP Prop?sito general - Deporte y recreaci?n - Once Doceavas
  "1.1.02.06.001.03.01||110205131||14301": "ADMON",            // SGP Prop?sito general - Deporte y recreaci?n - Ultima Doceava
  "1.1.02.06.001.03.02||11020514||14401": "ADMON",             // SGP Prop?sito general - Cultura Once Doceavas
  "1.1.02.06.001.03.02||110205141||14401": "ADMON",            // SGP Prop?sito general - Cultura - Ultima Doceava
  "1.1.02.06.001.03.03||11020515||14501": "ADMON",             // SGP Prop?sito general - Libre Inversion Once Doceavas
  "1.1.02.06.001.03.03||110205151||14501": "ADMON",            // SGP Prop?sito general - Libre Inversion Ultima doceava
  "1.1.02.06.001.04.01||11020516||14101": "ADMON",             // SGP Alimentaci?n escolar Once Doceavas
  "1.1.02.06.001.04.01||110205161||14101": "ADMON",            // SGP Alimentaci?n escolar Ultima Doceava
  "1.1.02.06.001.05||11020517||14201": "ADMON",                // SGP Prop?sito general - Agua potable Once Doceavas
  "1.1.02.06.001.05||11020518||14201": "ADMON",                // SGP Prop?sito general - Agua potable - 10% PDA SSF
  "1.1.02.06.001.05||110205171||14201": "ADMON",               // SGP Prop?sito general - Agua potable Ultima Doceava
  "1.1.02.06.003.01.02||11010103||11001": "ADMON",             // Impuesto Vehiculos Automotores
  "1.1.02.06.003.02.01||11020103||21201": "FSRI",              // Contribuci?n Fondo de Solidaridad y Redistribuci?n del Ingreso - Subsidios Acueducto
  "1.1.02.06.003.02.01||11020104||21201": "FSRI",              // Contribuci?n Fondo de Solidaridad y Redistribuci?n del Ingreso - Subsidios Alcantarillado
  "1.1.02.06.003.02.01||110201031||21201": "FSRI",             // Contribuci?n Fondo de Solidaridad y Redistribuci?n del Ingreso - Subsidios Aseo
  "1.1.02.06.005.05||110205301||31001": "ADMON",               // Seguridad Alimentaria  PAE- Departamento
  "1.1.02.06.006.06||110205308||61002": "ADMON",               // Ley del tabaco
  "1.1.02.06.009.01.06||11026103||23003": "FLS",               // 0,4 % IVC Super Salud SSF
  "1.1.02.06.009.01.06||11026105||23001": "FLS",               // ADRES Continuidad Regimen Subsidiado SSF
  "1.1.02.06.009.01.11.09||11026104||23006": "FLS",            // Regimen Subsidiado Departamento SSF
  "1.1.02.07.001.07||11026107||23004": "FLS",                  // Regimen Subsidiado Coljuegos 75% SSF
  "1.1.02.07.001.09||11026411||23301": "FLS",                  // Coljuegos 25% Funcionamiento
  "1.2.05.02||11020315||11001": "ADMON",                       // Intereses Sanciones Urbanisticas
  "1.2.05.02||11026110||23001": "FLS",                         // Recursos propios de Rendimientos ADRESS Sin Situacion de Fondos
  "1.2.05.02||11026214||23101": "FLS",                         // Rendimientos financieros S.G.P Salud Publica  60%
  "1.2.05.02||11026224||23101": "FLS",                         // Rendimientos financieros S.G.P Salud Publica 40%
  "1.2.05.02||11026304||23202": "FLS",                         // Rendimientos S.G.P Prestacion de servicios
  "1.2.05.02||11026413||23302": "FLS",                         // Rendimientos Otros Gastos en Salud INVERSION
  "1.2.05.02||11026414||23301": "FLS",                         // Rendimientos Otros Gastos en Salud FUNCIONAMIENTO - Coljuegos 25%
  "1.2.05.02||11026415||23005": "FLS",                         // Rendimientos Financieros SGP Regimen Subsidiado
  "1.2.05.02||11026416||14701": "ELIMINAR",                    // Rendimientos SGP Atenci?n Integral Primera Infancia
  "1.2.05.02||11026420||41001": "ELIMINAR",                    // Rendimientos Financieros - Gesti?n del Riesgo DAPARD
  "1.2.05.02||11026421||61001": "ADMON",                       // Rendimientos Financieros - Contribuci?n sector el?ctrico - Generadores de energ?a convencional -Proyecto porce II
  "1.2.05.02||12010102||14001": "ADMON",                       // Rendimientos financieros S.G.P Educacion
  "1.2.05.02||12010103||14201": "ADMON",                       // Rendimientos S.G.P agua potable
  "1.2.05.02||12010104||14501": "ADMON",                       // Rendimientos S.G.P otros sectores
  "1.2.05.02||12010105||14101": "ADMON",                       // rendimientos S..G.P Alimentacion escolar
  "1.2.05.02||12010107||51001": "ADMON",                       // Rendimientos financieros recursos del credito
  "1.2.05.02||12010108||14201": "ADMON",                       // Rendimientos S.G.P agua potable - PDA SSF
  "1.2.05.02||12010110||21201": "ADMON",                       // Rendimientos Financieros Fondo de Solidaridad y Redistribucion del Ingreso
  "1.2.05.02||12010110||21401": "ADMON",                       // Rendimientos Financieros Fondo de Solidaridad y Redistribucion del Ingreso
  "1.2.05.02||12010116||15001": "ADMON",                       // Rendimientos  REGALIAS ASIGNACIONES DIRECTAS
  "1.2.05.02||12040101||11001": "ADMON",                       // Rendimientos Financieros
  "1.2.05.02||110206110||23001": "FLS",                        // Rendimientos ADRESS Sin Situacion de Fondos
  "1.2.05.02||110262141||23101": "FLS",                        // Rendimientos financieros SGP Salud Publica 60%
  "1.2.05.02||120701004||51001": "ADMON",                      // Recursos del cr?dito
  "1.2.07.01.001||120701004||51001": "ADMON",                  // Recursos del cr?dito
  "1.2.07.01.004||120701004||51001": "ADMON",                  // Recursos del cr?dito
  "1.2.13.01||12040102||11001": "ADMON",                       // Reintegros
  "1.1.02.03.001.20.01||11020305||12007": "ADMON",             // Multas ambientales (C.RES del reporte 2026)
};

/* Fondo de una captura: primero CCPET+C.RES+FUENTE; si no hay, CCPET+C.RES
   (solo si esa pareja tiene un único fondo en el mapa). null = sin fondo. */
const FONDO_PAR = (() => {
  const m = {};
  Object.entries(FONDO_MAP).forEach(([k, f]) => {
    const [c, r] = k.split("||"); const p = `${c}||${r}`;
    m[p] = m[p] === undefined || m[p] === f ? f : "__VARIOS__";
  });
  return m;
})();
const fondoDe = (c) => {
  const f = FONDO_MAP[`${c.ccpet}||${c.cres ?? ""}||${c.fuente_codigo ?? ""}`]
         ?? FONDO_PAR[`${c.ccpet}||${c.cres ?? ""}`];
  return f && f !== "__VARIOS__" ? f : null;
};

const FONDOS_CONFIG = [
  { key:"f1", id:"ADMON",                   titulo:"ADMON",                    desc:"Administración Central",                              color:"#1e40af", bg:"#dbeafe" },
  { key:"f2", id:"FLS",                     titulo:"FLS",                      desc:"Fondo Local de Salud (por subcuentas)",             color:"#7c3aed", bg:"#ede9fe" },
  { key:"f3", id:"FONDO GESTION DEL RIESGO",titulo:"Fondo Gestión del Riesgo", desc:"Recursos para gestión del riesgo",                    color:"#b45309", bg:"#fef3c7" },
  { key:"f4", id:"FONSET",                  titulo:"FONSET",                   desc:"Fondo de Seguridad y Convivencia Ciudadana",           color:"#dc2626", bg:"#fee2e2" },
  { key:"f5", id:"FSRI",                    titulo:"FSRI",                     desc:"Fondo de Solidaridad y Redistribución del Ingreso",    color:"#065f46", bg:"#d1fae5" },
  { key:"f6", id:null,                      titulo:"Sin fondo asignado",       desc:"Rubros que no están en la tabla de fondos (para que cuadre el total)", color:"#6b7280", bg:"#f3f4f6" },
];

/* ── Helpers ──────────────────────────────────────────────────────────────── */
const fCOP = (v) => {
  if (v === null || v === undefined || isNaN(v) || v === "") return "—";
  return new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP",
    minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(v);
};

const fPct = (v) => {
  if (v === null || v === undefined) return "—";
  return <span style={{ color: v > 0 ? "#16a34a" : v < 0 ? "#dc2626" : "#6b7280", fontWeight: 600 }}>
    {v > 0 ? "+" : ""}{v}%</span>;
};

const ML = {
  auto: "a. Automático",
  prom: "b. Promedios",
  mixt: "c. Mixto",
  mc:   "d. Mín. Cuadrados",
  inc:  "e. Incr. Porcentual",
  prop: "f. Propio",
};

/* ── Cálculo de 5 métodos ─────────────────────────────────────────────────── */
function calcM(item, anios, inf, mix) {
  const vals = anios.map(a => item.recaudos?.[a] ?? null).filter(v => v !== null && v > 0);
  const n = vals.length;
  if (n === 0) return null;
  const ult = vals[vals.length - 1];
  const auto = Math.round(ult * (1 + inf / 100));
  const prom = Math.round(vals.reduce((a, b) => a + b, 0) / n);
  const mixt = Math.round(ult * (1 + mix / 100));
  const xs = n % 2 === 1
    ? vals.map((_, i) => i - Math.floor(n / 2))
    : vals.map((_, i) => i - n / 2 + 0.5);
  const sY = vals.reduce((a, b) => a + b, 0);
  const sXY = vals.reduce((s, y, i) => s + xs[i] * y, 0);
  const sX2 = xs.reduce((s, x) => s + x * x, 0);
  const mc = Math.round(sY / n + (sX2 > 0 ? sXY / sX2 : 0) * (xs[xs.length - 1] + 1));
  const ts = [];
  for (let i = 1; i < vals.length; i++) if (vals[i - 1] > 0) ts.push((vals[i] - vals[i - 1]) / vals[i - 1]);
  const tp = ts.length > 0 ? ts.reduce((a, b) => a + b, 0) / ts.length : 0;
  return { auto, prom, mixt, mc, inc: Math.round(ult * (1 + tp)), tp: Math.round(tp * 10000) / 100, ult };
}

/* ── Tildes dañadas en el reporte de origen ("Educaci�n", "c?digo") ─────────
   Se corrigen las palabras más comunes para mostrar y descargar los nombres bien. */
const TILDES = [
  [/([cst])i[\uFFFD?]n\b/gi, (m, l) => l + "ión"],          // ción, sión, tión
  [/([CST])I[\uFFFD?]N\b/g, (m, l) => l + "IÓN"],
  [/p[\uFFFD?]blic/g, "públic"], [/P[\uFFFD?]blic/g, "Públic"], [/P[\uFFFD?]BLIC/g, "PÚBLIC"],
  [/c[\uFFFD?]digo/gi, "código"], [/polic[\uFFFD?]a/gi, "policía"], [/R[\uFFFD?]gimen/g, "Régimen"],
  [/r[\uFFFD?]gimen/g, "régimen"], [/Regim[\uFFFD?]n/g, "Régimen"], [/Medell[\uFFFD?]n/g, "Medellín"],
  [/tel[\uFFFD?]fono/gi, "teléfono"], [/espect[\uFFFD?]culo/gi, "espectáculo"], [/tr[\uFFFD?]nsito/gi, "tránsito"],
  [/Matr[\uFFFD?]cula/g, "Matrícula"], [/veh[\uFFFD?]culo/gi, "vehículo"], [/Prop[\uFFFD?]sito/g, "Propósito"],
  [/el[\uFFFD?]ctric/gi, "eléctric"], [/energ[\uFFFD?]a/gi, "energía"], [/cr[\uFFFD?]dito/gi, "crédito"],
  [/[\uFFFD?]ltima/g, "última"], [/[\uFFFD]ltima/g, "Última"], [/Atenci[\uFFFD?]n/g, "Atención"],
  [/ \uFFFD /g, " – "],                                         // guion suelto dañado
  [/DEP[\uFFFD?]RTAMENTO/g, "DEPARTAMENTO"], [/deg[\uFFFD?]ello/gi, "degüello"], [/Dise[\uFFFD?]o/g, "Diseño"],
];
const arreglarTildes = t => (t == null ? t : TILDES.reduce((x, [re, por]) => x.replace(re, por), String(t)));

/* ── Descarga CSV ─────────────────────────────────────────────────────────── */
function descargar(filas, yr) {
  const bom = "\uFEFF";
  const cab = ["CCPET","NOMBRE","FUENTE","C.RES","TIPO","MÉTODO","VALOR PROYECTADO","OBSERVACIONES"].join(";");
  const rows = filas.map(f => [
    f.ccpet, `"${f.nombre}"`, f.fuente ?? "", f.cres ?? "",
    f.esAgg ? "Agregado" : "Captura",
    f.met, String(Math.round(f.val || 0)).replace(".", ","),
    `"${(f.obs ?? "").replace(/"/g, "'")}"`,
  ].join(";"));
  const blob = new Blob([bom + cab + "\n" + rows.join("\n")], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `ProyeccionIngresos_${yr}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}

/* ── Descarga CSV por fuente de financiación (mismo formato de la hoja del Excel) ──
   Los valores van con punto de miles (80.209.530.111): Excel en español los lee como número
   y no los muestra como 1,75947E+11. */
const miles = v => Math.round(v || 0).toLocaleString("es-CO", { useGrouping: true, maximumFractionDigits: 0 });
function descargarFuentes(fuentes, total, yr, completo = false) {
  const q = t => `"${String(t ?? "").replace(/"/g, "'")}"`;
  const lineas = [
    [`PROYECCION TOTAL INGRESOS ${yr}`, miles(total), "", ""].join(";"),
    ["FUENTE DE FINANCIACION", "TOTAL FUENTE DE FINANCIACION", "N° RUBROS", "% DEL TOTAL"].join(";"),
    ...fuentes.map(f => [q(f.etiqueta), miles(f.total), f.rubros.length,
      (total ? f.total / total * 100 : 0).toFixed(2).replace(".", ",")].join(";")),
  ];
  // Completo: debajo del resumen, cada rubro con su fuente y su subtotal por fuente
  if (completo) {
    lineas.push("", ["FUENTE DE FINANCIACION", "CCPET", "C.RES", "NOMBRE", "METODO", "VALOR PROYECTADO"].join(";"));
    fuentes.forEach(f => {
      f.rubros.forEach(r => lineas.push([q(f.etiqueta), r.ccpet, r.cres ?? "", q(r.nombre), q(r.met), miles(r.val)].join(";")));
      lineas.push([q(`SUBTOTAL ${f.etiqueta}`), "", "", "", "", miles(f.total)].join(";"));
    });
    lineas.push([q("TOTAL"), "", "", "", "", miles(total)].join(";"));
  }
  const blob = new Blob(["\uFEFF" + lineas.join("\r\n")], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = completo ? `fuentes_financiacion_${yr}_completo.csv` : `fuentes_financiacion_${yr}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}

/* ── Subcuentas del Fondo Local de Salud ─────────────────────────────────────
   Regla (en este orden):
   1) Fuente 23xyy: 230 = Régimen Subsidiado, 231 = Salud Pública, 232 = Prestación de servicios,
      233 = Otros gastos en salud.
   2) Nombre con "FLS RS / FLS SP / FLS PS / FLS OGS" (esfuerzo propio del predial).
   3) C.RES 110261 / 110262 / 110263 / 110264 (y 1102061 = rendimientos ADRES → Régimen Subsidiado). */
const SUBCUENTAS_FLS = [
  { id: "RS",  titulo: "Subcuenta de Régimen Subsidiado",           color: "#7c3aed" },
  { id: "SP",  titulo: "Subcuenta de Salud Pública Colectiva",      color: "#0e7490" },
  { id: "PSS", titulo: "Subcuenta de Prestación de Servicios de Salud (oferta)", color: "#b45309" },
  { id: "OGS", titulo: "Subcuenta de Otros Gastos en Salud",        color: "#065f46" },
  { id: "SIN", titulo: "Sin subcuenta identificada",                color: "#6b7280" },
];
const subcuentaFLS = (c) => {
  const m = String(c.fuente_codigo ?? "").match(/^23(\d)/);
  if (m) return { "0": "RS", "1": "SP", "2": "PSS", "3": "OGS" }[m[1]] ?? "SIN";
  const n = String(c.nombre ?? "").toUpperCase();
  if (n.includes("FLS RS"))  return "RS";
  if (n.includes("FLS SP"))  return "SP";
  if (n.includes("FLS PS"))  return "PSS";
  if (n.includes("FLS OGS")) return "OGS";
  const r = String(c.cres ?? "");
  if (r.startsWith("110261") || r.startsWith("1102061")) return "RS";
  if (r.startsWith("110262")) return "SP";
  if (r.startsWith("110263")) return "PSS";
  if (r.startsWith("110264")) return "OGS";
  return "SIN";
};

/* Descarga de uno o varios "mini presupuestos" (subcuentas del FLS) con estructura CCPET:
   bloques = [{ titulo, filas: [{ ccpet, nombre, cres, esAgg, met, val }], total }] */
function descargarPresupuestos(bloques, totalGeneral, tituloGeneral, archivo) {
  const q = t => `"${String(t ?? "").replace(/"/g, "'")}"`;
  const lineas = [];
  bloques.forEach((bq, i) => {
    if (i > 0) lineas.push("");
    lineas.push([q(bq.titulo.toUpperCase()), "", "", "", "", ""].join(";"));
    lineas.push(["CCPET", "NOMBRE", "C.RES", "TIPO", "MÉTODO", "VALOR PROYECTADO"].join(";"));
    bq.filas.forEach(f => lineas.push([f.ccpet, q(f.nombre), f.cres ?? "", f.esAgg ? "Agregado" : "Captura",
      f.esAgg ? "Sumatoria" : q(f.met), miles(f.val)].join(";")));
    lineas.push([q(`TOTAL ${bq.titulo.toUpperCase()}`), "", "", "", "", miles(bq.total)].join(";"));
  });
  if (bloques.length > 1) lineas.push("", [q(tituloGeneral), "", "", "", "", miles(totalGeneral)].join(";"));
  const blob = new Blob(["\uFEFF" + lineas.join("\r\n")], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = archivo;
  a.click();
  URL.revokeObjectURL(a.href);
}

/* ── Lo que queda fijo arriba al bajar ───────────────────────────────────── */
const BARRA_ALTO = 58;   // alto de la barra de secciones

// Lleva la vista al elemento si quedó por encima de la pantalla (al cerrar algo)
const volverA = (id, margen = BARRA_ALTO + 8) => requestAnimationFrame(() => {
  const el = document.getElementById(id);
  if (el && el.getBoundingClientRect().top < margen) el.scrollIntoView({ block: "start", behavior: "smooth" });
});

// Caja de tabla: se desplaza por dentro y el encabezado de columnas queda fijo
const cajaTabla = { overflow: "auto", maxHeight: "max(320px, calc(var(--alto-util, 100vh) - 260px))",
  border: "1px solid #e5e7eb", borderRadius: "10px" };
const fijoArriba = { position: "sticky", top: 0, zIndex: 3 };

/* ── Componente desplegable ───────────────────────────────────────────────── */
function Bloque({ id, titulo, sub, param, open, onToggle, children, badge }) {
  const alternar = () => { const cerrando = open; onToggle(); if (cerrando) volverA(id); };
  return (
    <div id={id} style={{ background: "#fff", borderRadius: "16px", border: "1px solid #e5e7eb",
      boxShadow: "0 4px 14px rgba(0,0,0,0.05)", marginBottom: "1rem", overflow: "clip",
      scrollMarginTop: BARRA_ALTO + 8 }}>
      <div onClick={alternar} title={open ? "Clic para cerrar" : "Clic para abrir"}
        style={{ padding: "1.1rem 1.5rem", cursor: "pointer",
        display: "flex", justifyContent: "space-between", alignItems: "center",
        position: open ? "sticky" : "static", top: BARRA_ALTO, zIndex: 15,
        boxShadow: open ? "0 6px 12px -8px rgba(22,59,140,0.35)" : "none",
        background: open ? "#eff6ff" : "#fff", borderBottom: open ? "1px solid #dbeafe" : "none" }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexWrap: "wrap" }}>
            <h2 style={{ margin: 0, color: "#163b8c", fontSize: "1.2rem", fontWeight: 700 }}>{titulo}</h2>
            {badge && <span style={{ background: "#163b8c", color: "#fff", borderRadius: "999px",
              padding: "0.15rem 0.65rem", fontSize: "0.86rem", fontWeight: 700 }}>{badge}</span>}
            {sub && <span style={{ fontSize: "0.96rem", color: "#6b7280" }}>{sub}</span>}
          </div>
          {param && <div style={{ marginTop: "0.35rem" }}>{param}</div>}
        </div>
        <span style={{ display: "flex", alignItems: "center", gap: "0.4rem",
          color: "#163b8c", fontWeight: 600, fontSize: "1.02rem", marginLeft: "1rem", flexShrink: 0 }}>
          {open ? <><ChevronDown size={16} />Ocultar</> : <><ChevronRight size={16} />Ver</>}
        </span>
      </div>
      {open && (
        <div style={{ padding: "1.25rem 1.5rem" }}>
          {children}
          <div style={{ display: "flex", justifyContent: "center", marginTop: "1.25rem" }}>
            <button type="button" onClick={alternar}
              style={{ display: "flex", alignItems: "center", gap: "0.4rem", border: "1px solid #bfdbfe",
                background: "#eff6ff", color: "#163b8c", borderRadius: "999px", padding: "0.45rem 1.1rem",
                fontWeight: 700, fontSize: "0.96rem", cursor: "pointer" }}>
              ▲ Cerrar {titulo}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

/* ── Tabla método individual ──────────────────────────────────────────────── */
function TMetodo({ items, mkey, ajuste, q = "", setQ = () => {} }) {
  // ajuste (opcional, solo método c): { general, valorDe(it), setPct(it, v), limpiar(it), limpiarTodos() }
  // q / setQ: la búsqueda vive en el componente principal para que no se pierda al cerrar
  const th = (e = {}) => ({ ...fijoArriba, padding: "0.55rem 0.75rem", background: "#163b8c", color: "#fff",
    fontWeight: 700, fontSize: "0.9rem", textAlign: "left", whiteSpace: "nowrap", ...e });
  const td = (i, e = {}) => ({ padding: "0.45rem 0.75rem", fontSize: "0.94rem",
    background: i % 2 === 0 ? "#f8faff" : "#fff", borderBottom: "1px solid #e5e7eb",
    verticalAlign: "middle", ...e });
  const flt = items.filter(it => {
    const s = q.toLowerCase();
    return !s || it.ccpet.toLowerCase().includes(s) || it.nombre.toLowerCase().includes(s)
      || String(it.cres ?? "").toLowerCase().includes(s);
  });
  const nPropios = ajuste ? items.filter(it => ajuste.valorDe(it) !== "").length : 0;
  return (<>
    <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexWrap: "wrap", marginBottom: "1rem" }}>
      <input type="text" placeholder="Buscar CCPET, C.RES o nombre..." value={q} onChange={e => setQ(e.target.value)}
        style={{ padding: "0.55rem 1rem", borderRadius: "8px", border: "1px solid #d1d5db",
          fontSize: "1.06rem", width: "300px", maxWidth: "100%", outline: "none" }} />
      {ajuste && (<>
        <span style={{ fontSize: "0.96rem", color: "#6b7280" }}>
          Deja el % vacío para usar el ajuste general ({ajuste.general}%).
          {nPropios > 0 && <> · <strong style={{ color: "#b45309" }}>{nPropios} rubro{nPropios === 1 ? "" : "s"} con % propio</strong></>}
        </span>
        {nPropios > 0 && (
          <button type="button" onClick={() => {
              if (window.confirm(`¿Quitar el % propio de ${nPropios} rubro${nPropios === 1 ? "" : "s"} y volver todos al ajuste general (${ajuste.general}%)?`)) ajuste.limpiarTodos();
            }}
            style={{ border: "1px solid #fcd34d", background: "#fffbeb", color: "#92400e", borderRadius: "8px",
              padding: "0.35rem 0.75rem", fontSize: "0.94rem", fontWeight: 600, cursor: "pointer" }}>
            Volver todos al general
          </button>
        )}
      </>)}
    </div>
    <div style={cajaTabla}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead><tr>
          <th style={th()}>CCPET</th><th style={th()}>C.RES</th>
          <th style={th({ minWidth: "180px" })}>NOMBRE</th>
          <th style={th({ textAlign: "right" })}>Últ. recaudo</th>
          {ajuste && <th style={th({ textAlign: "center", background: "#b45309" })}>% ajuste</th>}
          <th style={th({ textAlign: "right" })}>Proyección</th>
        </tr></thead>
        <tbody>
          {flt.map((it, i) => !it._m ? null : (
            <tr key={it._rk}>
              <td style={td(i)}><code style={{ fontSize: "0.88rem" }}>{it.ccpet}</code></td>
              <td style={td(i, { fontSize: "0.88rem", color: "#6b7280" })}>{it.cres ?? "—"}</td>
              <td style={td(i, { maxWidth: "240px" })}>{it.nombre}</td>
              <td style={{ ...td(i), textAlign: "right", fontFamily: "monospace", fontSize: "0.91rem" }}>{fCOP(it._m.ult)}</td>
              {ajuste && (() => {
                const v = ajuste.valorDe(it), propio = v !== "";
                return (
                  <td style={{ ...td(i), textAlign: "center", whiteSpace: "nowrap",
                    background: propio ? "#fffbeb" : td(i).background }}>
                    <input type="number" step="0.1" value={v} placeholder={String(ajuste.general)}
                      onChange={e => ajuste.setPct(it, e.target.value)}
                      title="Vacío = usa el ajuste general"
                      style={{ width: "84px", textAlign: "right", padding: "0.2rem 0.35rem", borderRadius: "6px",
                        border: `1px solid ${propio ? "#f59e0b" : "#d1d5db"}`, outline: "none",
                        fontSize: "0.91rem", fontWeight: propio ? 700 : 400,
                        color: propio ? "#92400e" : "#6b7280", background: "#fff" }} />
                    <span style={{ marginLeft: "0.25rem", fontSize: "0.89rem", color: "#6b7280" }}>%</span>
                    {propio && (
                      <button type="button" onClick={() => ajuste.limpiar(it)} title="Volver al ajuste general"
                        style={{ marginLeft: "0.3rem", border: "none", background: "transparent",
                          color: "#b45309", cursor: "pointer", fontWeight: 700, fontSize: "0.96rem" }}>×</button>
                    )}
                  </td>
                );
              })()}
              <td style={{ ...td(i), textAlign: "right", fontFamily: "monospace", fontSize: "0.91rem", fontWeight: 700, color: "#163b8c" }}>{fCOP(it._m[mkey])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>);
}

/* ── Componente principal ─────────────────────────────────────────────────── */
export default function ProyeccionIngresos() {
  const navigate = useNavigate();
  const fRef = useRef();

  const [datos, setDatos]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [subiendo, setSubiendo] = useState(false);
  const [msg, setMsg]         = useState(null);
  const leerLocal = (k, def) => { try { const v = JSON.parse(localStorage.getItem(k)); return v ?? def; } catch { return def; } };
  const [inf, setInf]         = useState(() => leerLocal("proyeccion_inf", 6.5));
  const [mix, setMix]         = useState(() => leerLocal("proyeccion_mix", 5));
  // % de ajuste del método c por rubro: { rk: "8.5" }. Vacío/ausente = usa el ajuste general.
  const [mixRubro, setMixRubro] = useState(() => {
    try { return JSON.parse(localStorage.getItem("proyeccion_mix_rubro")) || {}; } catch { return {}; }
  });
  const guardarMixRubro = (fn) => setMixRubro(p => {
    const n = fn(p);
    try { localStorage.setItem("proyeccion_mix_rubro", JSON.stringify(n)); } catch {}
    return n;
  });
  const setMixDe = (it, v) => guardarMixRubro(p => {
    const n = { ...p };
    if (v === "" || v === null || isNaN(parseFloat(v))) delete n[it._rk]; else n[it._rk] = v;
    return n;
  });
  // { rk: 'auto'|'prom'|...|'prop' } — se guarda en el navegador igual que los valores propios
  const [mets, setMets]       = useState(() => {
    try { return JSON.parse(localStorage.getItem("proyeccion_mets")) || {}; } catch { return {}; }
  });
  const [propios, setPropios] = useState(() => leerLocal("proyeccion_propios", {}));  // { rk: { valor: '', obs: '' } }
  const [expanded, setExpanded] = useState({});
  const [qR, setQR]           = useState("");
  const [qH, setQH]           = useState("");
  // Tamaño de todo el módulo (para PC grande o TV): 80 % a 160 %, recordado en este navegador
  const [escala, setEscala] = useState(() => {
    const v = Number(leerLocal("proyeccion_escala", 0));
    if (v >= 0.8 && v <= 1.6) return v;
    // Primera vez: en pantallas muy anchas (TV) arranca más grande
    const w = typeof window !== "undefined" ? window.innerWidth : 1400;
    return w >= 3000 ? 1.5 : w >= 2200 ? 1.25 : 1;
  });
  useEffect(() => { try { localStorage.setItem("proyeccion_escala", JSON.stringify(escala)); } catch {} }, [escala]);
  const cambiarEscala = d => setEscala(e => Math.min(1.6, Math.max(0.8, Math.round((e + d) * 10) / 10)));

  // Qué secciones están abiertas: se recuerda en este navegador para la próxima vez
  const [uiGuardada] = useState(() => leerLocal("proyeccion_ui_abiertos", {}));
  const [open, setOpen]       = useState({ h:false, r:false, res:false, ff:false, liq:false, metodos:false, fondos:false, ...(uiGuardada.open ?? {}) });
  const [openMetodo, setOpenMetodo] = useState({ a:false, b:false, c:false, d:false, e:false, ...(uiGuardada.metodo ?? {}) });
  const [openFondo, setOpenFondo] = useState({ f1:false, f2:false, f3:false, f4:false, f5:false, f6:false, ...(uiGuardada.fondo ?? {}) });
  useEffect(() => {
    try { localStorage.setItem("proyeccion_ui_abiertos", JSON.stringify({ open, metodo: openMetodo, fondo: openFondo })); } catch {}
  }, [open, openMetodo, openFondo]);
  const tog  = k => setOpen(p => ({ ...p, [k]: !p[k] }));
  const togM = k => { const cerrando = openMetodo[k]; setOpenMetodo(p => ({ ...p, [k]: !p[k] })); if (cerrando) volverA(`met-${k}`, 140); };
  const togF = k => { const cerrando = openFondo[k];  setOpenFondo(p => ({ ...p, [k]: !p[k] }));  if (cerrando) volverA(`fondo-${k}`, 140); };
  // Búsqueda de cada método (se conserva al cerrar y abrir)
  const [qMet, setQMet] = useState({});
  const [abiertasSub, setAbiertasSub] = useState({});   // subcuentas del FLS desplegadas
  // Ir a una sección desde la barra: la abre si está cerrada y baja hasta ella
  const irA = (k, id) => {
    setOpen(p => ({ ...p, [k]: true }));
    requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView({ block: "start", behavior: "smooth" }));
  };
  const SECCIONES = [
    { k: "h",       id: "sec-h",       t: "Histórico" },
    { k: "r",       id: "sec-r",       t: "Proyección" },
    { k: "res",     id: "sec-res",     t: "Resumen" },
    { k: "ff",      id: "sec-ff",      t: "Fuentes" },
    { k: "liq",     id: "sec-liq",     t: "Liquidación" },
    { k: "metodos", id: "sec-metodos", t: "Métodos" },
    { k: "fondos",  id: "sec-fondos",  t: "Fondos" },
  ];

  // Respaldo local de inflación y ajuste general
  useEffect(() => { try { localStorage.setItem("proyeccion_inf", JSON.stringify(inf)); } catch {} }, [inf]);
  useEffect(() => { try { localStorage.setItem("proyeccion_mix", JSON.stringify(mix)); } catch {} }, [mix]);

  const savePropios = (newPropios) => {
    setPropios(newPropios);
    try { localStorage.setItem("proyeccion_propios", JSON.stringify(newPropios)); } catch {}
  };

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        apiConfig.getUrl("/api/hacienda/proyeccion-ingresos/consultar/") + `?t=${Date.now()}`,
        { credentials: "include", cache: "no-store" });
      setDatos(await res.json());
    } catch { setDatos(null); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  /* Eliminar una vigencia (vig = año) o todas (vig = null) */
  const [eliminando, setEliminando] = useState(null);
  const eliminar = async (vig) => {
    const v = (datos?.vigencias ?? []).find(x => Number(x.vigencia) === Number(vig));
    if (vig !== null) {
      const regs = v?.total_registros != null ? Number(v.total_registros).toLocaleString("es-CO") : "todos los";
      if (!window.confirm(`¿Eliminar la vigencia ${vig}?\n\nSe borrarán ${regs} registros del archivo "${v?.nombre_archivo ?? ""}". Esta acción no se puede deshacer.`)) return;
    } else {
      const txt = window.prompt("Se eliminarán TODAS las vigencias cargadas y sus registros. Esta acción no se puede deshacer.\n\nEscriba ELIMINAR para confirmar:");
      if ((txt ?? "").trim().toUpperCase() !== "ELIMINAR") return;
    }
    setEliminando(vig ?? "todas"); setMsg(null);
    try {
      const res = await fetch(apiConfig.getUrl("/api/hacienda/proyeccion-ingresos/eliminar/"), {
        method: "POST", credentials: "include", cache: "no-store",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(vig === null ? { todas: true } : { vigencia: Number(vig) }),
      });
      const txt = await res.text();
      let d = {};
      try { d = txt ? JSON.parse(txt) : {}; } catch { d = { error: txt.slice(0, 200) }; }
      if (!res.ok || d.error) throw new Error(d.error || `El servidor respondió ${res.status} sin detalle`);
      setMsg({ ok: true, t: d.mensaje });
      await load();
    } catch (err) { setMsg({ ok: false, t: `No se pudo eliminar: ${err.message}` }); }
    finally { setEliminando(null); }
  };

  const handleUp = async e => {
    const file = e.target.files?.[0]; if (!file) return;
    e.target.value = ""; setSubiendo(true); setMsg(null);
    const fd = new FormData(); fd.append("file", file);
    try {
      const res = await fetch(apiConfig.getUrl("/api/hacienda/proyeccion-ingresos/cargar/"),
        { method: "POST", body: fd, credentials: "include" });
      const d = await res.json();
      if (d.error) throw new Error(d.error);
      setMsg({ ok: true, t: d.mensaje }); load();
    } catch (err) { setMsg({ ok: false, t: err.message }); }
    finally { setSubiendo(false); }
  };

  const anios = useMemo(() => (datos?.anios ?? []).map(String), [datos]);
  const yr    = anios.length > 0 ? Math.max(...anios.map(Number)) + 1 : null;

  /* ── Configuración guardada en la base de datos ───────────────────────────
     Métodos elegidos, valores propios, observaciones, % por rubro, inflación y
     ajuste general. Se guarda una configuración por año proyectado (proyeccion_2027)
     y se carga sola al entrar, desde cualquier computador. */
  const URL_CFG  = "/api/hacienda/proyeccion-ingresos/config/";
  const claveCfg = yr ? `proyeccion_${yr}` : null;
  const [cfg, setCfg] = useState({ listo: false, estado: "cargando", hora: null, error: null });
  const [cfgIntento, setCfgIntento] = useState(0);
  const cfgCargada  = useRef(null);   // clave ya leída del servidor
  const cfgUltimo   = useRef(null);   // último contenido guardado (evita guardar lo mismo)
  const paqueteCfg  = (o) => JSON.stringify({ inf: o.inf, mix: o.mix, mets: o.mets, propios: o.propios, mixRubro: o.mixRubro });
  const leerJSON = async (res) => {
    const txt = await res.text();
    let d = {};
    try { d = txt ? JSON.parse(txt) : {}; } catch { d = { error: txt.slice(0, 200) }; }
    if (!res.ok || d.error) throw new Error(d.error || `El servidor respondió ${res.status} sin detalle`);
    return d;
  };

  // Leer la configuración guardada al entrar (o al cambiar el año proyectado)
  useEffect(() => {
    if (!claveCfg || cfgCargada.current === claveCfg) return;
    let cancelado = false;
    setCfg(c => ({ ...c, listo: false, estado: "cargando", error: null }));
    (async () => {
      try {
        const res = await fetch(apiConfig.getUrl(URL_CFG) + `?clave=${claveCfg}&t=${Date.now()}`,
          { credentials: "include", cache: "no-store" });
        const d = await leerJSON(res);
        if (cancelado) return;
        if (d.datos) {
          const c = {
            inf:      typeof d.datos.inf === "number" ? d.datos.inf : inf,
            mix:      typeof d.datos.mix === "number" ? d.datos.mix : mix,
            mets:     d.datos.mets     ?? {},
            propios:  d.datos.propios  ?? {},
            mixRubro: d.datos.mixRubro ?? {},
          };
          setInf(c.inf); setMix(c.mix); setMets(c.mets); setPropios(c.propios); setMixRubro(c.mixRubro);
          cfgUltimo.current = paqueteCfg(c);
          setCfg({ listo: true, estado: "guardado", hora: d.actualizado, error: null });
        } else {
          // Primera vez para este año: se sube lo que haya en este navegador
          cfgUltimo.current = null;
          setCfg({ listo: true, estado: "guardando", hora: null, error: null });
        }
        cfgCargada.current = claveCfg;
      } catch (err) {
        // Sin leer el servidor NO se guarda nada, para no pisar la configuración existente
        if (!cancelado) setCfg({ listo: false, estado: "error", hora: null,
          error: `No se pudo leer la configuración guardada: ${err.message}` });
      }
    })();
    return () => { cancelado = true; };
  }, [claveCfg, cfgIntento]);

  // Guardar automáticamente cada cambio (espera 0,8 s después del último cambio)
  useEffect(() => {
    if (!cfg.listo || !claveCfg) return;
    const paquete = paqueteCfg({ inf, mix, mets, propios, mixRubro });
    if (paquete === cfgUltimo.current) return;
    const t = setTimeout(async () => {
      setCfg(c => ({ ...c, estado: "guardando" }));
      try {
        const res = await fetch(apiConfig.getUrl(URL_CFG), {
          method: "POST", credentials: "include", cache: "no-store",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ clave: claveCfg, datos: JSON.parse(paquete) }),
        });
        const d = await leerJSON(res);
        cfgUltimo.current = paquete;
        setCfg(c => ({ ...c, estado: "guardado", hora: d.actualizado, error: null }));
      } catch (err) {
        setCfg(c => ({ ...c, estado: "error", error: `No se pudo guardar: ${err.message}` }));
      }
    }, 800);
    return () => clearTimeout(t);
  }, [cfg.listo, claveCfg, inf, mix, mets, propios, mixRubro, cfgIntento]);

  // ¿Hay cambios que aún no llegan a la base de datos?
  const cfgPendiente = cfg.listo && paqueteCfg({ inf, mix, mets, propios, mixRubro }) !== cfgUltimo.current;

  useEffect(() => {
    if (!cfgPendiente) return;
    const avisar = e => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", avisar);
    return () => window.removeEventListener("beforeunload", avisar);
  }, [cfgPendiente]);

  // Botón Guardar: guarda de inmediato, sin esperar el guardado automático
  const guardarAhora = async () => {
    if (!claveCfg) return;
    if (!cfg.listo) {   // no se pudo leer lo guardado: primero se reintenta la lectura
      cfgCargada.current = null; setCfgIntento(n => n + 1); return;
    }
    const paquete = paqueteCfg({ inf, mix, mets, propios, mixRubro });
    setCfg(c => ({ ...c, estado: "guardando" }));
    try {
      const res = await fetch(apiConfig.getUrl(URL_CFG), {
        method: "POST", credentials: "include", cache: "no-store",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ clave: claveCfg, datos: JSON.parse(paquete) }),
      });
      const d = await leerJSON(res);
      cfgUltimo.current = paquete;
      setCfg(c => ({ ...c, estado: "guardado", hora: d.actualizado, error: null }));
    } catch (err) {
      setCfg(c => ({ ...c, estado: "error", error: `No se pudo guardar: ${err.message}` }));
    }
  };

  // Botón + estado, reutilizado en Proyección de Ingresos y en Métodos de cálculo
  const botonGuardar = () => {
    const ocupado = cfg.estado === "cargando" || cfg.estado === "guardando";
    const txt = cfg.estado === "cargando" ? "Cargando..."
              : cfg.estado === "guardando" ? "Guardando..."
              : !cfg.listo ? "Reintentar"
              : "Guardar";
    const nota = cfg.estado === "error" ? <span style={{ color:"#991b1b" }}>{cfg.error}</span>
               : cfgPendiente ? <span style={{ color:"#b45309" }}>Cambios sin guardar</span>
               : cfg.estado === "guardado" ? <span style={{ color:"#15803d" }}>✓ Guardado{cfg.hora ? ` · ${cfg.hora}` : ""}</span>
               : null;
    return (
      <div style={{ display:"inline-flex", alignItems:"center", gap:"0.6rem", flexWrap:"wrap" }}
        onClick={e => e.stopPropagation()}>
        <button type="button" onClick={guardarAhora} disabled={ocupado || !claveCfg}
          style={{ display:"flex", alignItems:"center", gap:"0.45rem",
            background: ocupado ? "#86efac" : "#15803d", color:"#fff", border:"none", borderRadius:"10px",
            padding:"0.6rem 1.1rem", fontWeight:700, fontSize:"1.06rem",
            cursor: ocupado ? "not-allowed" : "pointer", boxShadow:"0 4px 12px rgba(21,128,61,0.2)" }}>
          <Save size={16}/> {txt}
        </button>
        {nota && <span style={{ fontSize:"0.94rem", fontWeight:600 }}>{nota}</span>}
      </div>
    );
  };

  // Llave de cada fila: CCPET + C.RES + FUENTE. Sin consecutivo: cambia de un año a otro.
  const rk = it => [it.ccpet ?? "", it.cres ?? "", it.fuente_codigo ?? "",
    it.es_captura ? "cap" : "agg"].join("||");

  /* Capturas: una fila por CCPET + C.RES + FUENTE con el recaudo de cada año.
     Si llegan filas repetidas (otro consecutivo u otra vigencia) se unen sumando por año. */
  const caps = useMemo(() => {
    const unidas = {};
    (datos?.capturas ?? datos?.ccpets ?? [])
      .filter(it => it.ccpet && !it.ccpet.startsWith("1.2.10"))
      .forEach(it => {
        const k = [it.ccpet, it.cres ?? "", it.fuente_codigo ?? ""].join("||");
        if (!unidas[k]) unidas[k] = { ...it, consecutivo: null, recaudos: {} };
        const u = unidas[k];
        if (it.nombre && !/[?�]/.test(it.nombre)) u.nombre = it.nombre;
        if (it.fuente_nombre) u.fuente_nombre = it.fuente_nombre;
        u.nombre = arreglarTildes(u.nombre);
        u.fuente_nombre = arreglarTildes(u.fuente_nombre);
        Object.entries(it.recaudos ?? {}).forEach(([a, v]) => {
          u.recaudos[String(a)] = (u.recaudos[String(a)] || 0) + (Number(v) || 0);
        });
      });
    return Object.values(unidas).map(it => {
      const item = { ...it, es_captura: true };
      item._rk = rk(item);
      const pr = mixRubro[item._rk];
      item._mixPropio = pr !== undefined && pr !== "" && !isNaN(parseFloat(pr));
      item._mixPct    = item._mixPropio ? parseFloat(pr) : mix;
      item._m  = calcM(item, anios, inf, item._mixPct);
      return item;
    });
  }, [datos, anios, inf, mix, mixRubro]);

  const hijosDe = (ccpetPadre) => {
    const pref = ccpetPadre + ".";
    return caps.filter(c => c._m && (
      c.ccpet === ccpetPadre ||           // misma cuenta, distinto cres/fuente
      c.ccpet?.startsWith(pref)           // cuentas hijas más profundas
    ));
  };

  /* Agregados: todos los niveles padres de las capturas (1, 1.1, 1.1.01, ...).
     Se generan aquí para no depender de que el servidor los envíe;
     el nombre se toma del servidor cuando existe. */
  const aggs = useMemo(() => {
    const nombres = {};
    (datos?.agregados ?? []).forEach(a => { if (a.ccpet) nombres[a.ccpet] = arreglarTildes(a.nombre); });

    const conteo = {};
    caps.forEach(c => { conteo[c.ccpet] = (conteo[c.ccpet] || 0) + 1; });

    const niveles = new Set();
    caps.forEach(c => {
      const partes = c.ccpet.split(".");
      for (let i = 1; i < partes.length; i++) niveles.add(partes.slice(0, i).join("."));
      // la cuenta propia también es nivel si agrupa varias capturas
      if (conteo[c.ccpet] > 1 || nombres[c.ccpet]) niveles.add(c.ccpet);
    });

    const ultAnio = anios[anios.length - 1];
    return [...niveles].map(ccpet => {
      const item = { ccpet, nombre: nombres[ccpet] ?? `Cuenta ${ccpet}`,
        cres: null, fuente_codigo: null, es_captura: false };
      item._rk = rk(item);
      const hj = hijosDe(ccpet);
      const rec = {};
      anios.forEach(a => { rec[a] = hj.reduce((s, c) => s + (Number(c.recaudos?.[a]) || 0), 0); });
      item.recaudos = rec;
      item._m = hj.length > 0 ? {
        auto: null, prom: null, mixt: null, mc: null, inc: null,
        ult: Math.round(rec[ultAnio] || 0), tp: null,
      } : null;
      return item;
    });
  }, [datos, anios, caps]);

  useEffect(() => {
    if (!aggs.length) return;
    const init = {};
    aggs.forEach(a => { if (a.ccpet.split(".").length <= 2) init[a.ccpet] = true; });
    setExpanded(init);
  }, [datos]);

  const todas = useMemo(() => [...aggs, ...caps].sort((a, b) => {
    const pa = a.ccpet.split(".").map(Number), pb = b.ccpet.split(".").map(Number);
    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
      const d = (pa[i] ?? 0) - (pb[i] ?? 0); if (d) return d;
    }
    return a.es_captura ? 1 : -1;
  }), [aggs, caps]);

  const tieneHijos = (it) => !it.es_captura && todas.some(x => x.ccpet !== it.ccpet && x.ccpet.startsWith(it.ccpet + "."));

  const esVisible = (it) => {
    const partes = it.ccpet.split(".");
    if (partes.length === 1) return true;
    for (let i = 1; i < partes.length; i++) {
      const anc = partes.slice(0, i).join(".");
      if (todas.some(x => x.ccpet === anc && !x.es_captura) && expanded[anc] === false) return false;
    }
    return true;
  };

  /* Método y valor para una fila */
  const getM = it => it.es_captura ? (mets[it._rk] ?? "auto") : "sum";
  const getV = it => {
    if (!it.es_captura) {
      return Math.round(hijosDe(it.ccpet).reduce((s, c) => {
        const m = mets[c._rk] ?? "auto";
        return s + (m === "prop" ? (parseFloat(propios[c._rk]?.valor) || 0) : (Number(c._m?.[m]) || 0));
      }, 0));
    }
    const m = mets[it._rk] ?? "auto";
    if (m === "prop") return parseFloat(propios[it._rk]?.valor) || 0;
    return it._m ? (it._m[m] ?? 0) : 0;
  };

  const setM  = (it, v) => {
    if (!it.es_captura) return;
    setMets(p => {
      const n = { ...p, [it._rk]: v };
      try { localStorage.setItem("proyeccion_mets", JSON.stringify(n)); } catch {}
      return n;
    });
  };
  const setPV = (it, campo, val) => {
    const np = { ...propios, [it._rk]: { ...propios[it._rk], [campo]: val } };
    savePropios(np);
  };

  // Fila tal como sale en el Excel descargado (la usan la descarga y la sección Resumen)
  const filaExcel = it => ({
    ccpet: it.ccpet, nombre: it.nombre,
    fuente: it.fuente_codigo ?? "", cres: it.cres ?? "",
    esAgg: !it.es_captura,
    met: it.es_captura ? (ML[getM(it)] ?? getM(it)) : "Sumatoria",
    val: getV(it),
    obs: propios[it._rk]?.obs ?? "",
  });

  // Resumen: TODAS las filas (sin depender de qué esté abierto en Proyección), con su propia búsqueda
  const [qRes, setQRes] = useState("");
  const [soloAgg, setSoloAgg] = useState(false);
  const resumen = todas
    .filter(it => !soloAgg || !it.es_captura)
    .filter(it => {
      const q = qRes.trim().toLowerCase();
      return !q || it.ccpet.toLowerCase().includes(q) || (it.nombre ?? "").toLowerCase().includes(q)
        || String(it.cres ?? "").toLowerCase().includes(q) || String(it.fuente_codigo ?? "").includes(q);
    })
    .map(it => ({ ...filaExcel(it), _rk: it._rk, nivel: it.ccpet.split(".").length - 1 }));

  /* Mini presupuesto con estructura CCPET para un grupo de capturas (p. ej. una subcuenta del FLS):
     cada agregado suma solo las capturas del grupo. */
  const presupuestoDe = (capsGrupo) => {
    const enGrupo = new Set(capsGrupo.map(c => c._rk));
    const filasAgg = aggs.map(agg => {
      const hj = hijosDe(agg.ccpet).filter(c => enGrupo.has(c._rk));
      return hj.length ? { ccpet: agg.ccpet, nombre: agg.nombre, cres: "", esAgg: true, met: "Sumatoria",
        val: Math.round(hj.reduce((s, c) => s + getV(c), 0)), _rk: agg._rk } : null;
    }).filter(Boolean);
    const filasCap = capsGrupo.map(c => ({ ...filaExcel(c), _rk: c._rk }));
    const cmp = (a, b) => {
      const pa = a.ccpet.split(".").map(Number), pb = b.ccpet.split(".").map(Number);
      for (let i = 0; i < Math.max(pa.length, pb.length); i++) { const d = (pa[i] ?? 0) - (pb[i] ?? 0); if (d) return d; }
      return a.esAgg ? -1 : b.esAgg ? 1 : String(a.cres).localeCompare(String(b.cres));
    };
    const filas = [...filasAgg, ...filasCap].sort(cmp);
    return { filas, total: filasCap.reduce((s, f) => s + f.val, 0) };
  };

  // Suma por fuente de financiación (valor autorizado de cada captura, con su método)
  const [qFF, setQFF] = useState("");
  const [ordenFF, setOrdenFF] = useState("codigo");
  const [abiertasFF, setAbiertasFF] = useState({});
  const fuentesTodas = (() => {
    const m = {};
    caps.forEach(c => {
      const cod = c.fuente_codigo || "SIN";
      const etiqueta = c.fuente_codigo
        ? `${c.fuente_codigo}-${(c.fuente_nombre ?? "").trim()}`.replace(/-$/, "")
        : "Sin fuente de financiación";
      if (!m[cod]) m[cod] = { cod, etiqueta, total: 0, rubros: [] };
      const f = filaExcel(c);
      m[cod].total += f.val;
      m[cod].rubros.push(f);
    });
    return Object.values(m);
  })();
  const totalFF = fuentesTodas.reduce((s, f) => s + f.total, 0);
  const fuentesFF = fuentesTodas
    .filter(f => { const q = qFF.trim().toLowerCase(); return !q || f.etiqueta.toLowerCase().includes(q); })
    .sort((a, b) => ordenFF === "valor" ? b.total - a.total : a.cod.localeCompare(b.cod, "es", { numeric: true }));

  const flt = todas.filter(it => {
    const s = qR.toLowerCase();
    return !s || it.ccpet.toLowerCase().includes(s) || it.nombre.toLowerCase().includes(s) || String(it.cres ?? "").toLowerCase().includes(s);
  }).filter(esVisible);

  const hay = !loading && caps.length > 0;

  /* ── Estilos ── */
  const thH = { ...fijoArriba, padding: "0.5rem 0.65rem", background: "#163b8c", color: "#fff",
    fontWeight: 700, fontSize: "0.86rem", textAlign: "left", whiteSpace: "nowrap" };
  const tdH = (i, e = {}) => ({ padding: "0.4rem 0.65rem", fontSize: "0.9rem",
    background: i % 2 === 0 ? "#f8faff" : "#fff", borderBottom: "1px solid #e5e7eb",
    verticalAlign: "middle", ...e });
  const card = { background: "#fff", borderRadius: "16px", border: "1px solid #e5e7eb",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)", marginBottom: "1.5rem", overflow: "hidden" };
  const pInp = (val, onChange, lbl) => (
    <div style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem",
      background: "#fff", border: "1px solid #d1d5db", borderRadius: "8px",
      padding: "0.25rem 0.6rem", fontSize: "0.98rem" }}
      onClick={e => e.stopPropagation()}>
      <span style={{ color: "#6b7280" }}>{lbl}</span>
      <input type="number" value={val} onChange={onChange}
        style={{ width: "74px", border: "none", outline: "none", fontSize: "1.06rem",
          fontWeight: 700, color: "#163b8c", textAlign: "right" }} />
      <span style={{ color: "#6b7280" }}>%</span>
    </div>
  );

  /* ── Vista liquidación: solo agregados, cada uno suma sus capturas con el método elegido ── */
  const cmpCcpet = (a, b) => {
    const pa = a.split(".").map(Number), pb = b.split(".").map(Number);
    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
      const d = (pa[i] ?? -1) - (pb[i] ?? -1); if (d) return d;
    }
    return 0;
  };
  const liquidacion = useMemo(() => aggs
    .map(agg => ({
      ccpet:    agg.ccpet,
      nombre:   agg.nombre,
      nivel:    agg.ccpet.split(".").length - 1,
      ult:      agg._m?.ult ?? 0,       // recaudo del último año cargado (suma de capturas hijas)
      proy:     getV(agg),              // suma de valores autorizados de las capturas hijas
    }))
    .filter(l => l.ult > 0 || l.proy > 0)
    .sort((a, b) => cmpCcpet(a.ccpet, b.ccpet)),
  [aggs, caps, mets, propios]);

  // Abrir/cerrar niveles de la liquidación (por defecto abiertos hasta el 3er nivel)
  const [expLiq, setExpLiq] = useState({});
  const liqAbierto = c => expLiq[c] ?? (c.split(".").length <= 3);
  const liqTieneHijos = c => liquidacion.some(l => l.ccpet.startsWith(c + "."));
  const liqVisible = c => {
    const p = c.split(".");
    for (let i = 1; i < p.length; i++) {
      const anc = p.slice(0, i).join(".");
      if (liquidacion.some(l => l.ccpet === anc) && !liqAbierto(anc)) return false;
    }
    return true;
  };
  const liqVisibles = liquidacion.filter(l => liqVisible(l.ccpet));
  const liqRaices = liquidacion.filter(l => !liquidacion.some(o => o.ccpet !== l.ccpet && l.ccpet.startsWith(o.ccpet + ".")));
  const liqTotUlt  = liqRaices.reduce((s, l) => s + l.ult, 0);
  const liqTotProy = liqRaices.reduce((s, l) => s + l.proy, 0);

  return (
    <div style={{ minHeight: "100vh", background: "#f3f4f6",
      padding: "clamp(1rem, 2vw, 2.5rem) clamp(0.75rem, 2.5vw, 4rem)" }}>
      <div style={{ width: "100%", maxWidth: "3200px", margin: "0 auto", zoom: escala,
        "--alto-util": `calc(100vh / ${escala})` }}>

        <button type="button" onClick={() => navigate("/hacienda-presupuesto")}
          style={{ background: "#e5e7eb", color: "#111827", border: "none", borderRadius: "10px",
            padding: "0.7rem 1rem", cursor: "pointer", fontWeight: 600, marginBottom: "1.5rem" }}>
          ← Volver a Hacienda
        </button>

        <div style={{ marginBottom: "1.5rem" }}>
          <h1 style={{ margin: 0, color: "#163b8c", fontSize: "2.3rem", fontWeight: 800 }}>Proyección de Ingresos</h1>
          <p style={{ marginTop: "0.5rem", color: "#6b7280" }}>
            Ejecuciones históricas · 5 métodos + valor propio · Ministerio de Hacienda
            {yr && <> · Proyectando <strong>{yr}</strong></>}
          </p>
          {yr && (
            <div style={{ marginTop: "0.5rem", display: "inline-flex", alignItems: "center", gap: "0.5rem",
              padding: "0.3rem 0.8rem", borderRadius: "999px", fontSize: "0.96rem", fontWeight: 600,
              background: cfg.estado === "error" ? "#fef2f2" : cfg.estado === "guardado" ? "#f0fdf4" : "#eff6ff",
              color:      cfg.estado === "error" ? "#991b1b" : cfg.estado === "guardado" ? "#15803d" : "#1e40af",
              border: `1px solid ${cfg.estado === "error" ? "#fca5a5" : cfg.estado === "guardado" ? "#bbf7d0" : "#bfdbfe"}` }}>
              {cfg.estado === "cargando"  && "Cargando métodos y ajustes guardados..."}
              {cfg.estado === "guardando" && "Guardando cambios..."}
              {cfg.estado === "guardado"  && <>✓ Métodos y ajustes guardados{cfg.hora ? ` · ${cfg.hora}` : ""}</>}
              {cfg.estado === "error" && (<>
                {cfg.error}
                <button type="button"
                  onClick={() => { if (!cfg.listo) cfgCargada.current = null; setCfgIntento(n => n + 1);
                    if (cfg.listo) { cfgUltimo.current = null; setCfg(c => ({ ...c, estado: "guardando" })); } }}
                  style={{ border: "1px solid #fca5a5", background: "#fff", color: "#991b1b", borderRadius: "999px",
                    padding: "0.1rem 0.6rem", fontSize: "0.9rem", fontWeight: 700, cursor: "pointer" }}>
                  Reintentar
                </button>
              </>)}
            </div>
          )}
        </div>

        {/* ── Vigencias ── */}
        <div style={{ ...card, padding: "1.5rem" }}>
          <h2 style={{ margin: "0 0 1rem", color: "#163b8c", fontSize: "1.32rem", fontWeight: 700 }}>Vigencias cargadas</h2>
          {(datos?.vigencias ?? []).length > 0 && (
            <div style={{ marginBottom: "1.2rem", borderRadius: "10px", overflow: "hidden", border: "1px solid #e5e7eb" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "1.06rem" }}>
                <thead><tr style={{ background: "#163b8c" }}>
                  {["Vigencia","Archivo","Registros","Fecha cargue","Estado","Acción"].map(h => (
                    <th key={h} style={{ padding: "0.65rem 1rem", color: "#fff", fontWeight: 700,
                      textAlign: ["Registros","Estado","Acción"].includes(h) ? "center" : "left" }}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {(datos?.vigencias ?? []).map((v, i) => (
                    <tr key={v.vigencia} style={{ background: i%2===0?"#f0f6ff":"#fff", borderBottom: "1px solid #e5e7eb" }}>
                      <td style={{ padding:"0.65rem 1rem", fontWeight:800, color:"#163b8c" }}>{v.vigencia}</td>
                      <td style={{ padding:"0.65rem 1rem", color:"#6b7280", fontSize:"0.98rem",
                        maxWidth:"220px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                        {v.nombre_archivo ?? "—"}
                      </td>
                      <td style={{ padding:"0.65rem 1rem", textAlign:"center", fontWeight:600 }}>
                        {v.total_registros != null ? Number(v.total_registros).toLocaleString("es-CO") : "—"}
                      </td>
                      <td style={{ padding:"0.65rem 1rem", color:"#6b7280", fontSize:"0.98rem" }}>
                        {new Date(v.fecha_cargue).toLocaleString("es-CO", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" })}
                      </td>
                      <td style={{ padding:"0.65rem 1rem", textAlign:"center" }}>
                        <span style={{ display:"inline-flex", alignItems:"center", gap:"0.3rem",
                          background:"#dcfce7", color:"#15803d", borderRadius:"999px",
                          padding:"0.25rem 0.75rem", fontWeight:700, fontSize:"0.94rem" }}>
                          <CheckCircle size={12}/> Cargada
                        </span>
                      </td>
                      <td style={{ padding:"0.65rem 1rem", textAlign:"center" }}>
                        <button type="button" onClick={() => eliminar(v.vigencia)}
                          disabled={eliminando !== null || subiendo}
                          title={`Eliminar vigencia ${v.vigencia}`}
                          style={{ display:"inline-flex", alignItems:"center", gap:"0.35rem",
                            background:"#fff", color:"#dc2626", border:"1px solid #fca5a5", borderRadius:"8px",
                            padding:"0.3rem 0.7rem", fontWeight:700, fontSize:"0.94rem",
                            cursor: eliminando !== null ? "not-allowed" : "pointer",
                            opacity: eliminando !== null && eliminando !== v.vigencia ? 0.5 : 1 }}>
                          <Trash2 size={13}/> {eliminando === v.vigencia ? "Eliminando..." : "Eliminar"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {(datos?.vigencias ?? []).length === 0 && !loading && (
            <p style={{ color: "#9ca3af", marginBottom: "1rem" }}>Aún no hay vigencias cargadas.</p>
          )}
          <input ref={fRef} type="file" accept=".csv" style={{ display: "none" }} onChange={handleUp} />
          {(() => {
            const nVig = (datos?.vigencias ?? []).length;
            const maxAlcanzado = nVig >= 5;
            return (
              <div style={{ display:"flex", gap:"0.75rem", flexWrap:"wrap", alignItems:"center" }}>
              <button type="button"
                onClick={() => !maxAlcanzado && fRef.current.click()}
                disabled={subiendo || maxAlcanzado}
                style={{ display:"flex", alignItems:"center", gap:"0.5rem",
                  background: maxAlcanzado ? "#9ca3af" : subiendo ? "#93c5fd" : "#163b8c",
                  color:"#fff", border:"none", borderRadius:"10px", padding:"0.75rem 1.3rem", fontWeight:700,
                  cursor: (subiendo || maxAlcanzado) ? "not-allowed" : "pointer",
                  boxShadow:"0 4px 12px rgba(22,59,140,0.2)" }}>
                <Upload size={18}/>
                {maxAlcanzado ? "Máximo 5 vigencias alcanzado" : subiendo ? "Cargando..." : "Cargar vigencia histórica"}
              </button>
              {nVig > 0 && (
                <button type="button" onClick={() => eliminar(null)}
                  disabled={eliminando !== null || subiendo}
                  style={{ display:"flex", alignItems:"center", gap:"0.5rem",
                    background:"#fff", color:"#dc2626", border:"1px solid #fca5a5", borderRadius:"10px",
                    padding:"0.75rem 1.1rem", fontWeight:700,
                    cursor: eliminando !== null ? "not-allowed" : "pointer" }}>
                  <Trash2 size={16}/> {eliminando === "todas" ? "Eliminando..." : "Eliminar todas"}
                </button>
              )}
              </div>
            );
          })()}
          {(() => {
            const nVig = (datos?.vigencias ?? []).length;
            return (
              <div style={{ marginTop:"0.6rem" }}>
                <p style={{ margin:0, fontSize:"0.98rem", color:"#9ca3af" }}>
                  Archivo CSV de ejecución de ingresos (estructura CCPET). Una vigencia por vez.
                  {" "}<strong>Máximo 5 vigencias</strong> (ej: 2021–2025).
                  {nVig >= 5 && <span style={{ color:"#dc2626", fontWeight:600 }}> Ya tienes el máximo de 5 vigencias cargadas.</span>}
                </p>
                {nVig > 0 && nVig < 3 && (
                  <div style={{ marginTop:"0.6rem", padding:"0.75rem 1rem", borderRadius:"10px",
                    background:"#fffbeb", border:"1px solid #fde68a",
                    color:"#92400e", fontSize:"1.02rem", display:"flex", alignItems:"flex-start", gap:"0.5rem" }}>
                    <span style={{ fontSize:"1.32rem" }}>⚠️</span>
                    <span>
                      <strong>Tienes {nVig} vigencia{nVig===1?"":"s"} cargada{nVig===1?"":"s"}.</strong>{" "}
                      Cargar menos de 3 años de histórico puede no reflejar la realidad de los ingresos.
                      Se recomienda cargar al menos los años <strong>2022, 2023 y 2024</strong>.
                    </span>
                  </div>
                )}
              </div>
            );
          })()}
          {msg && (
            <div style={{ marginTop:"1rem", padding:"0.85rem 1rem", borderRadius:"10px",
              background: msg.ok?"#f0fdf4":"#fef2f2",
              border:`1px solid ${msg.ok?"#bbf7d0":"#fca5a5"}`,
              color: msg.ok?"#15803d":"#991b1b",
              display:"flex", alignItems:"center", gap:"0.5rem", fontSize:"1.08rem" }}>
              {msg.ok ? <CheckCircle size={16}/> : <AlertCircle size={16}/>}{msg.t}
            </div>
          )}
        </div>

        {hay && (<>

          {/* ── Barra fija: ir a cada sección, abrir/cerrar todo y guardar ── */}
          <div style={{ position:"sticky", top:0, zIndex:30, height:BARRA_ALTO, boxSizing:"border-box",
            display:"flex", alignItems:"center", gap:"0.5rem", overflowX:"auto", whiteSpace:"nowrap",
            background:"rgba(243,244,246,0.97)", borderBottom:"1px solid #e5e7eb",
            margin:"0 0 1rem", padding:"0 0.25rem" }}>
            <span style={{ fontSize:"0.94rem", color:"#6b7280", fontWeight:600, marginRight:"0.25rem" }}>Ir a:</span>
            {SECCIONES.map(x => (
              <button key={x.k} type="button" onClick={() => irA(x.k, x.id)}
                title={open[x.k] ? "Abierta · clic para ir" : "Cerrada · clic para abrir e ir"}
                style={{ flexShrink:0, border:`1px solid ${open[x.k] ? "#163b8c" : "#d1d5db"}`,
                  background: open[x.k] ? "#163b8c" : "#fff", color: open[x.k] ? "#fff" : "#374151",
                  borderRadius:"999px", padding:"0.35rem 0.85rem", fontSize:"0.96rem", fontWeight:600, cursor:"pointer" }}>
                {x.t}
              </button>
            ))}
            <span style={{ width:1, height:24, background:"#d1d5db", margin:"0 0.25rem", flexShrink:0 }}/>
            <button type="button" onClick={() => setOpen(p => Object.fromEntries(Object.keys(p).map(k => [k, true])))}
              style={{ flexShrink:0, border:"1px solid #d1d5db", background:"#fff", color:"#374151", borderRadius:"8px",
                padding:"0.35rem 0.7rem", fontSize:"0.94rem", fontWeight:600, cursor:"pointer" }}>Abrir todas</button>
            <button type="button" onClick={() => { setOpen(p => Object.fromEntries(Object.keys(p).map(k => [k, false])));
                requestAnimationFrame(() => document.getElementById("sec-h")?.scrollIntoView({ block:"start", behavior:"smooth" })); }}
              style={{ flexShrink:0, border:"1px solid #d1d5db", background:"#fff", color:"#374151", borderRadius:"8px",
                padding:"0.35rem 0.7rem", fontSize:"0.94rem", fontWeight:600, cursor:"pointer" }}>Cerrar todas</button>
            <span style={{ width:1, height:24, background:"#d1d5db", margin:"0 0.25rem", flexShrink:0 }}/>
            <span style={{ display:"inline-flex", alignItems:"center", gap:"0.25rem", flexShrink:0 }}
              title="Tamaño de todo el módulo (útil en pantallas grandes o TV)">
              {[["A−", -0.1], ["A+", 0.1]].map(([t, d]) => (
                <button key={t} type="button" onClick={() => cambiarEscala(d)}
                  disabled={(d < 0 && escala <= 0.8) || (d > 0 && escala >= 1.6)}
                  style={{ border:"1px solid #d1d5db", background:"#fff", color:"#374151", borderRadius:"8px",
                    padding:"0.3rem 0.6rem", fontSize: d > 0 ? "1.02rem" : "0.86rem", fontWeight:700, cursor:"pointer" }}>{t}</button>
              ))}
              <button type="button" onClick={() => setEscala(1)} title="Volver al tamaño normal"
                style={{ border:"none", background:"transparent", color:"#6b7280", fontSize:"0.86rem",
                  fontWeight:600, cursor:"pointer", minWidth:"3.2rem" }}>{Math.round(escala * 100)}%</button>
            </span>
            <span style={{ marginLeft:"auto", flexShrink:0 }}>{botonGuardar()}</span>
          </div>

          {/* ── 1. Histórico de recaudo ── */}
          <Bloque id="sec-h" titulo="Histórico de recaudo por cuenta"
            badge={`${caps.length} cuentas`}
            sub={`Vigencias cargadas: ${anios.join(", ")}`}
            open={open.h} onToggle={() => tog("h")}>
            <input type="text" placeholder="Buscar CCPET, C.RES, fuente o nombre..." value={qH}
              onChange={e => setQH(e.target.value)}
              style={{ padding:"0.55rem 1rem", borderRadius:"8px", border:"1px solid #d1d5db",
                fontSize:"1.06rem", maxWidth:"300px", outline:"none", marginBottom:"1rem", display:"block" }}/>
            <div style={cajaTabla}>
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead><tr>
                  <th style={thH}>CCPET</th><th style={thH}>C.RES</th><th style={thH}>FUENTE</th>
                  <th style={{ ...thH, minWidth:"200px" }}>NOMBRE</th>
                  {anios.map(a => <th key={a} style={{ ...thH, textAlign:"right" }}>Rec. {a}</th>)}
                  <th style={{ ...thH, textAlign:"right", background:"#15803d" }}>Proyección {yr}</th>
                </tr></thead>
                <tbody>
                  {caps.filter(it => {
                    const s = qH.toLowerCase();
                    return !s || it.ccpet.toLowerCase().includes(s) || it.nombre.toLowerCase().includes(s)
                      || String(it.cres ?? "").toLowerCase().includes(s) || String(it.fuente_codigo ?? "").includes(s);
                  }).map((it, i) => (
                    <tr key={it._rk}>
                      <td style={tdH(i)}><code style={{ fontSize:"0.82rem" }}>{it.ccpet}</code></td>
                      <td style={tdH(i, { fontSize:"0.84rem", color:"#6b7280" })}>{it.cres ?? "—"}</td>
                      <td style={tdH(i, { fontSize:"0.84rem" })}>
                        {it.fuente_codigo ? <><strong>{it.fuente_codigo}</strong> · {it.fuente_nombre}</> : "—"}
                      </td>
                      <td style={tdH(i, { maxWidth:"240px" })}>{it.nombre}</td>
                      {anios.map(a => (
                        <td key={a} style={{ ...tdH(i), textAlign:"right", fontFamily:"monospace", fontSize:"0.86rem" }}>
                          {it.recaudos?.[a] > 0 ? fCOP(it.recaudos[a]) : <span style={{ color:"#d1d5db" }}>—</span>}
                        </td>
                      ))}
                      <td style={{ ...tdH(i), textAlign:"right", fontFamily:"monospace", fontSize:"0.86rem",
                        fontWeight:700, color:"#065f46", background: i%2===0?"#dcfce7":"#bbf7d0" }}>
                        {fCOP(getV(it))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Bloque>

          {/* ── 2. Resumen comparativo con Propio y Observaciones ── */}
          <Bloque id="sec-r" titulo="Proyección de Ingresos"
            badge={`${todas.length} filas`}
            sub={`Proyección ${yr}`}
            param={
              <div style={{ display:"flex", gap:"0.75rem", flexWrap:"wrap", marginTop:"0.35rem" }}
                onClick={e => e.stopPropagation()}>
                {pInp(inf, e => setInf(parseFloat(e.target.value)||0), "Inflación (a):")}
                {pInp(mix, e => setMix(parseFloat(e.target.value)||0), "Ajuste (c):")}
              </div>
            }
            open={open.r} onToggle={() => tog("r")}>

            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
              flexWrap:"wrap", gap:"0.75rem", marginBottom:"0.75rem" }}>
              <input type="text" placeholder="Buscar CCPET, nombre, C.RES..." value={qR}
                onChange={e => setQR(e.target.value)}
                style={{ padding:"0.55rem 1rem", borderRadius:"8px", border:"1px solid #d1d5db",
                  fontSize:"1.06rem", minWidth:"260px", outline:"none" }}/>
              <button type="button"
                onClick={() => descargar(flt.map(filaExcel), yr)}
                style={{ display:"flex", alignItems:"center", gap:"0.5rem",
                  background:"#163b8c", color:"#fff", border:"none", borderRadius:"10px",
                  padding:"0.6rem 1.2rem", fontWeight:700, fontSize:"1.06rem", cursor:"pointer" }}>
                <Download size={16}/> Descargar proyección {yr}
              </button>
              {botonGuardar()}
            </div>

            <p style={{ fontSize:"0.95rem", color:"#6b7280", margin:"0 0 0.75rem" }}>
              <strong style={{ color:"#1e3a8a" }}>Azul oscuro</strong> = agregados (suman capturas hijas).
              Usa <strong>f. Propio</strong> para ingresar un valor manual con justificación.
              Los métodos, valores propios y observaciones se guardan solos en el sistema; también puedes usar <strong>Guardar</strong>.
            </p>

            <div style={cajaTabla}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"0.85rem" }}>
                <thead><tr>
                  <th style={{ ...thH, minWidth:"165px" }}>CCPET</th>
                  <th style={thH}>C.RES</th>
                  <th style={{ ...thH, minWidth:"230px" }}>NOMBRE</th>
                  <th style={{ ...thH, textAlign:"right" }}>Últ. rec.</th>
                  <th style={{ ...thH, textAlign:"right" }}>a. Auto.</th>
                  <th style={{ ...thH, textAlign:"right" }}>b. Prom.</th>
                  <th style={{ ...thH, textAlign:"right" }}>c. Mixto</th>
                  <th style={{ ...thH, textAlign:"right" }}>d. Mín.C.</th>
                  <th style={{ ...thH, textAlign:"right" }}>e. Incr.</th>
                  <th style={{ ...thH, textAlign:"center", background:"#1e40af" }}>Método</th>
                  <th style={{ ...thH, textAlign:"right", background:"#15803d" }}>Valor autorizado</th>
                  <th style={{ ...thH, minWidth:"160px", background:"#374151" }}>Observaciones</th>
                </tr></thead>
                <tbody>
                  {flt.map((it, i) => {
                    const esA = !it.es_captura, m = it._m;
                    const bg = esA ? (i%2===0?"#dbeafe":"#bfdbfe") : (i%2===0?"#f8faff":"#fff");
                    const ct = esA ? "#1e3a8a" : "#111827", fw = esA ? 700 : 400;
                    const ms = getM(it), vs = getV(it);
                    const isProp = ms === "prop";
                    const propVal = propios[it._rk]?.valor ?? "";
                    const propObs = propios[it._rk]?.obs ?? "";
                    const tb = (e={}) => ({ padding:"0.35rem 0.6rem", fontSize:"0.85rem",
                      background:bg, borderBottom:"1px solid #e5e7eb",
                      verticalAlign:"middle", color:ct, fontWeight:fw, ...e });
                    const tr = (e={}) => tb({ textAlign:"right", fontFamily:"monospace", ...e });

                    return (
                      <tr key={it._rk}>
                        <td style={tb({ minWidth:"165px", whiteSpace:"nowrap" })}>
                          <div style={{ display:"flex", alignItems:"center", gap:"0.3rem" }}>
                            {!it.es_captura && tieneHijos(it) ? (
                              <button type="button"
                                onClick={() => setExpanded(p => ({ ...p, [it.ccpet]: !p[it.ccpet] }))}
                                style={{ border:"none", background:"transparent", cursor:"pointer",
                                  padding:0, display:"flex", alignItems:"center", color:"#1e40af" }}>
                                {expanded[it.ccpet] ? <ChevronDown size={13}/> : <ChevronRight size={13}/>}
                              </button>
                            ) : <span style={{ width:13, display:"inline-block" }}/>}
                            <code style={{ fontSize:"0.8rem", color:esA?"#1e40af":"#374151" }}>{it.ccpet}</code>
                          </div>
                        </td>
                        <td style={tb({ fontSize:"0.82rem", color:"#6b7280" })}>{it.cres ?? ""}</td>
                        <td style={tb({ maxWidth:"200px" })}>{it.nombre}</td>
                        <td style={tr({ color: esA ? "#1e40af" : ct, fontWeight: esA ? 700 : fw })}>{m && m.ult > 0 ? fCOP(m.ult) : "—"}</td>

                        {["auto","prom","mixt","mc","inc"].map(k => (
                          <td key={k} style={tr({
                            background: ms===k ? (i%2===0?"#bbf7d0":"#a7f3d0") : bg,
                            color: ms===k ? "#065f46" : ct, fontWeight: ms===k ? 700 : fw,
                          })}>
                            {it.es_captura ? (m ? fCOP(m[k]) : "—") : "—"}
                            {k === "mixt" && it.es_captura && it._mixPropio && (
                              <div style={{ fontSize: "0.74rem", color: "#b45309", fontWeight: 700 }}>
                                {it._mixPct}% propio
                              </div>
                            )}
                          </td>
                        ))}

                        {/* Selector de método */}
                        <td style={tb({ textAlign:"center", background:i%2===0?"#eff6ff":"#dbeafe" })}>
                          {it.es_captura ? (
                            <select value={ms} onChange={e => setM(it, e.target.value)}
                              style={{ fontSize:"0.84rem", border:"1px solid #93c5fd", borderRadius:"6px",
                                padding:"0.2rem 0.3rem", background:"#fff", cursor:"pointer",
                                color:"#1e40af", fontWeight:600, outline:"none" }}>
                              <option value="auto">a. Automático</option>
                              <option value="prom">b. Promedios</option>
                              <option value="mixt">c. Mixto</option>
                              <option value="mc">d. Mín. Cuadrados</option>
                              <option value="inc">e. Incr. Porcentual</option>
                              <option value="prop">f. Propio ✏️</option>
                            </select>
                          ) : <span style={{ color:"#1e3a8a", fontWeight:700, fontSize:"0.84rem" }}>Sumatoria</span>}
                        </td>

                        {/* Valor autorizado / campo propio */}
                        <td style={tr({ background:i%2===0?"#dcfce7":"#bbf7d0",
                          color:"#065f46", fontWeight:700 })}>
                          {it.es_captura && isProp ? (
                            <input type="number" placeholder="Ingrese valor"
                              value={propVal}
                              onChange={e => setPV(it, "valor", e.target.value)}
                              style={{ width:"135px", border:"1px solid #6ee7b7", borderRadius:"6px",
                                padding:"0.2rem 0.4rem", fontSize:"0.85rem", textAlign:"right",
                                color:"#065f46", fontWeight:700, outline:"none", background:"#fff" }}/>
                          ) : (
                            fCOP(vs)
                          )}
                        </td>

                        {/* Observaciones */}
                        <td style={tb({ background: isProp && it.es_captura ? (i%2===0?"#fffbeb":"#fef9c3") : bg })}>
                          {it.es_captura ? (
                            <input type="text"
                              placeholder={isProp ? "Ej: Aumento catastral 8%" : "Observación opcional..."}
                              value={propObs}
                              onChange={e => setPV(it, "obs", e.target.value)}
                              style={{ width:"100%", minWidth:"140px", border:`1px solid ${isProp?"#fbbf24":"#e5e7eb"}`,
                                borderRadius:"6px", padding:"0.2rem 0.4rem", fontSize:"0.84rem",
                                color:"#374151", outline:"none",
                                background: isProp ? "#fffbeb" : "transparent" }}/>
                          ) : <span style={{ color:"#6b7280", fontSize:"0.83rem" }}>—</span>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Bloque>

          {/* ── 2b. Resumen de la proyección: igual al Excel descargado ── */}
          <Bloque id="sec-res" titulo="Resumen de la proyección"
            badge={`${resumen.length} filas`}
            sub={`Mismas columnas del Excel descargado · Proyección ${yr}`}
            open={open.res} onToggle={() => tog("res")}>
            <div style={{ display:"flex", alignItems:"center", gap:"0.75rem", flexWrap:"wrap", marginBottom:"0.75rem" }}>
              <input type="text" placeholder="Buscar CCPET, nombre, C.RES o fuente..." value={qRes}
                onChange={e => setQRes(e.target.value)}
                style={{ padding:"0.55rem 1rem", borderRadius:"8px", border:"1px solid #d1d5db",
                  fontSize:"1.06rem", minWidth:"280px", outline:"none" }}/>
              <label style={{ display:"flex", alignItems:"center", gap:"0.4rem", fontSize:"1.02rem", color:"#374151", cursor:"pointer" }}>
                <input type="checkbox" checked={soloAgg} onChange={e => setSoloAgg(e.target.checked)}/>
                Solo agregados (sumatorias)
              </label>
              <button type="button" onClick={() => descargar(resumen, yr)}
                style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:"0.5rem",
                  background:"#163b8c", color:"#fff", border:"none", borderRadius:"10px",
                  padding:"0.6rem 1.2rem", fontWeight:700, fontSize:"1.06rem", cursor:"pointer" }}>
                <Download size={16}/> Descargar este resumen
              </button>
            </div>
            <p style={{ fontSize:"0.95rem", color:"#6b7280", margin:"0 0 0.75rem" }}>
              Se actualiza solo con los métodos, valores propios y observaciones de <strong>Proyección de Ingresos</strong>.
              Muestra todas las filas, aunque en Proyección haya niveles cerrados.
            </p>
            <div style={cajaTabla}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"0.9rem" }}>
                <thead><tr>
                  {["CCPET","NOMBRE","FUENTE","C.RES","TIPO","MÉTODO","VALOR PROYECTADO","OBSERVACIONES"].map(h => (
                    <th key={h} style={{ ...thH,
                      textAlign: h === "VALOR PROYECTADO" ? "right" : "left",
                      background: h === "VALOR PROYECTADO" ? "#15803d" : thH.background,
                      minWidth: h === "NOMBRE" ? "260px" : h === "OBSERVACIONES" ? "200px" : undefined }}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {resumen.map((f, i) => {
                    const bg = f.esAgg ? (i % 2 === 0 ? "#dbeafe" : "#bfdbfe") : (i % 2 === 0 ? "#f8faff" : "#fff");
                    const c = { padding:"0.4rem 0.65rem", background:bg, borderBottom:"1px solid #e5e7eb",
                      color: f.esAgg ? "#1e3a8a" : "#111827", fontWeight: f.esAgg ? 700 : 400, verticalAlign:"middle" };
                    return (
                      <tr key={f._rk}>
                        <td style={{ ...c, fontFamily:"monospace", whiteSpace:"nowrap" }}>{f.ccpet}</td>
                        <td style={{ ...c, paddingLeft: f.esAgg ? `${0.65 + f.nivel * 0.5}rem` : "0.65rem" }}>{f.nombre}</td>
                        <td style={c}>{f.fuente}</td>
                        <td style={{ ...c, color:"#6b7280" }}>{f.cres}</td>
                        <td style={c}>{f.esAgg ? "Agregado" : "Captura"}</td>
                        <td style={{ ...c, color:"#163b8c", fontWeight:600, whiteSpace:"nowrap" }}>{f.met}</td>
                        <td style={{ ...c, textAlign:"right", fontFamily:"monospace", whiteSpace:"nowrap",
                          background: i % 2 === 0 ? "#dcfce7" : "#bbf7d0", color:"#065f46", fontWeight:700 }}>
                          {fCOP(f.val)}
                        </td>
                        <td style={{ ...c, color:"#374151", fontWeight:400 }}>{f.obs}</td>
                      </tr>
                    );
                  })}
                  {resumen.length === 0 && (
                    <tr><td colSpan={8} style={{ padding:"1rem", textAlign:"center", color:"#9ca3af" }}>
                      No hay filas con esa búsqueda.
                    </td></tr>
                  )}
                </tbody>
                <tfoot><tr>
                  <td colSpan={6} style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.55rem 0.65rem",
                    color:"#fff", fontWeight:800, fontSize:"0.96rem" }}>
                    TOTAL PROYECCIÓN {yr}
                  </td>
                  <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.55rem 0.65rem",
                    textAlign:"right", color:"#fff", fontWeight:800, fontFamily:"monospace", fontSize:"0.98rem", whiteSpace:"nowrap" }}>
                    {fCOP(liqTotProy)}
                  </td>
                  <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c" }}/>
                </tr></tfoot>
              </table>
            </div>
          </Bloque>

          {/* ── 2c. Suma por fuente de financiación ── */}
          <Bloque id="sec-ff" titulo="Proyección por fuente de financiación"
            badge={`${fuentesTodas.length} fuentes`}
            sub={`Suma del valor autorizado de cada rubro · Proyección ${yr}`}
            open={open.ff} onToggle={() => tog("ff")}>
            <div style={{ display:"flex", alignItems:"center", gap:"0.75rem", flexWrap:"wrap", marginBottom:"0.75rem" }}>
              <input type="text" placeholder="Buscar fuente (código o nombre)..." value={qFF}
                onChange={e => setQFF(e.target.value)}
                style={{ padding:"0.55rem 1rem", borderRadius:"8px", border:"1px solid #d1d5db",
                  fontSize:"1.06rem", minWidth:"280px", outline:"none" }}/>
              <label style={{ fontSize:"1rem", color:"#374151" }}>
                Ordenar por{" "}
                <select value={ordenFF} onChange={e => setOrdenFF(e.target.value)}
                  style={{ fontSize:"1rem", padding:"0.3rem 0.5rem", borderRadius:"6px", border:"1px solid #d1d5db" }}>
                  <option value="codigo">código de fuente</option>
                  <option value="valor">mayor valor</option>
                </select>
              </label>
              <div style={{ marginLeft:"auto", display:"flex", gap:"0.5rem", flexWrap:"wrap" }}>
                <button type="button" onClick={() => descargarFuentes(fuentesFF, totalFF, yr)}
                  style={{ display:"flex", alignItems:"center", gap:"0.5rem", background:"#163b8c", color:"#fff",
                    border:"none", borderRadius:"10px", padding:"0.6rem 1.2rem", fontWeight:700, fontSize:"1.06rem", cursor:"pointer" }}>
                  <Download size={16}/> Descargar por fuente
                </button>
                <button type="button" onClick={() => descargarFuentes(fuentesFF, totalFF, yr, true)}
                  title="El resumen por fuente y, debajo, cada rubro con su fuente y subtotal"
                  style={{ display:"flex", alignItems:"center", gap:"0.5rem", background:"#fff", color:"#163b8c",
                    border:"1px solid #163b8c", borderRadius:"10px", padding:"0.6rem 1.2rem", fontWeight:700, fontSize:"1.06rem", cursor:"pointer" }}>
                  <Download size={16}/> Descargar completo (con rubros)
                </button>
              </div>
            </div>
            <p style={{ fontSize:"0.95rem", color:"#6b7280", margin:"0 0 0.75rem" }}>
              Cada fuente suma el <strong>valor autorizado</strong> de sus rubros, con el método elegido en Proyección de Ingresos.
              Clic en una fuente para ver sus rubros.
            </p>
            <div style={cajaTabla}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"1rem" }}>
                <thead>
                  <tr>
                    <th style={{ ...thH, background:"#0f2a66" }}>PROYECCION TOTAL INGRESOS {yr}</th>
                    <th style={{ ...thH, background:"#0f2a66", textAlign:"right", fontFamily:"monospace", fontSize:"1.06rem" }}>{fCOP(totalFF)}</th>
                    <th style={{ ...thH, background:"#0f2a66" }}/>
                    <th style={{ ...thH, background:"#0f2a66" }}/>
                  </tr>
                  <tr>
                    <th style={{ ...thH, top:"2.4rem", minWidth:"360px" }}>FUENTE DE FINANCIACIÓN</th>
                    <th style={{ ...thH, top:"2.4rem", textAlign:"right", background:"#15803d" }}>TOTAL FUENTE DE FINANCIACIÓN</th>
                    <th style={{ ...thH, top:"2.4rem", textAlign:"center" }}>RUBROS</th>
                    <th style={{ ...thH, top:"2.4rem", textAlign:"right" }}>% DEL TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  {fuentesFF.map((f, i) => {
                    const ab = !!abiertasFF[f.cod];
                    const bg = i % 2 === 0 ? "#f8faff" : "#fff";
                    const c = { padding:"0.55rem 0.75rem", background:bg, borderBottom:"1px solid #e5e7eb", verticalAlign:"middle" };
                    return [
                      <tr key={f.cod} onClick={() => setAbiertasFF(p => ({ ...p, [f.cod]: !p[f.cod] }))} style={{ cursor:"pointer" }}>
                        <td style={{ ...c, fontWeight:600, color:"#163b8c" }}>
                          <span style={{ display:"inline-flex", alignItems:"center", gap:"0.35rem" }}>
                            {ab ? <ChevronDown size={14}/> : <ChevronRight size={14}/>}{f.etiqueta}
                          </span>
                        </td>
                        <td style={{ ...c, textAlign:"right", fontFamily:"monospace", fontWeight:700, color:"#065f46",
                          background: i % 2 === 0 ? "#dcfce7" : "#bbf7d0" }}>{fCOP(f.total)}</td>
                        <td style={{ ...c, textAlign:"center", color:"#6b7280" }}>{f.rubros.length}</td>
                        <td style={{ ...c, textAlign:"right", color:"#374151" }}>
                          {totalFF ? `${(f.total / totalFF * 100).toFixed(2).replace(".", ",")}%` : "—"}
                        </td>
                      </tr>,
                      ab && (
                        <tr key={f.cod + "_det"}>
                          <td colSpan={4} style={{ padding:"0.25rem 0.75rem 0.75rem 2.2rem", background:"#f9fafb", borderBottom:"1px solid #e5e7eb" }}>
                            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"0.92rem" }}>
                              <thead><tr>
                                {["CCPET","C.RES","NOMBRE","MÉTODO","VALOR AUTORIZADO"].map(h => (
                                  <th key={h} style={{ textAlign: h === "VALOR AUTORIZADO" ? "right" : "left", padding:"0.35rem 0.5rem",
                                    color:"#374151", borderBottom:"1px solid #d1d5db", fontWeight:700 }}>{h}</th>
                                ))}
                              </tr></thead>
                              <tbody>
                                {f.rubros.map(r => (
                                  <tr key={r.ccpet + r.cres + r.nombre}>
                                    <td style={{ padding:"0.3rem 0.5rem", fontFamily:"monospace" }}>{r.ccpet}</td>
                                    <td style={{ padding:"0.3rem 0.5rem", color:"#6b7280" }}>{r.cres}</td>
                                    <td style={{ padding:"0.3rem 0.5rem" }}>{r.nombre}</td>
                                    <td style={{ padding:"0.3rem 0.5rem", color:"#163b8c", fontWeight:600 }}>{r.met}</td>
                                    <td style={{ padding:"0.3rem 0.5rem", textAlign:"right", fontFamily:"monospace" }}>{fCOP(r.val)}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      ),
                    ];
                  })}
                  {fuentesFF.length === 0 && (
                    <tr><td colSpan={4} style={{ padding:"1rem", textAlign:"center", color:"#9ca3af" }}>No hay fuentes con esa búsqueda.</td></tr>
                  )}
                </tbody>
                <tfoot><tr>
                  <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.6rem 0.75rem", color:"#fff", fontWeight:800 }}>
                    TOTAL {qFF ? "(fuentes filtradas)" : "FUENTES DE FINANCIACIÓN"}
                  </td>
                  <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.6rem 0.75rem", color:"#fff",
                    fontWeight:800, textAlign:"right", fontFamily:"monospace" }}>{fCOP(fuentesFF.reduce((s, f) => s + f.total, 0))}</td>
                  <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.6rem 0.75rem", color:"#fff", textAlign:"center" }}>
                    {fuentesFF.reduce((s, f) => s + f.rubros.length, 0)}
                  </td>
                  <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c" }}/>
                </tr></tfoot>
              </table>
            </div>
          </Bloque>

          {/* ── 3. Vista Liquidación (estilo TD) ── */}
          <Bloque id="sec-liq" titulo="Vista Liquidación — Proyección consolidada por nivel"
            badge={`${liquidacion.length} niveles`}
            sub={`Suma de capturas por método seleccionado · Proyección ${yr}`}
            open={open.liq} onToggle={() => tog("liq")}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
              flexWrap:"wrap", gap:"0.75rem", margin:"0 0 1rem" }}>
              <p style={{ fontSize:"0.96rem", color:"#6b7280", margin:0, maxWidth:"760px" }}>
                Cada nivel suma sus cuentas de captura con el método elegido en <strong>Proyección de Ingresos</strong>
                {" "}(las que no tienen método elegido usan Automático). Usa las flechas para abrir o cerrar niveles.
              </p>
              <div style={{ display:"flex", gap:"0.5rem" }}>
                <button type="button"
                  onClick={() => setExpLiq(Object.fromEntries(liquidacion.map(l => [l.ccpet, true])))}
                  style={{ border:"1px solid #93c5fd", background:"#fff", color:"#1e40af", borderRadius:"8px",
                    padding:"0.4rem 0.8rem", fontSize:"0.94rem", fontWeight:600, cursor:"pointer" }}>
                  Abrir todo
                </button>
                <button type="button"
                  onClick={() => setExpLiq(Object.fromEntries(liquidacion.map(l => [l.ccpet, false])))}
                  style={{ border:"1px solid #93c5fd", background:"#fff", color:"#1e40af", borderRadius:"8px",
                    padding:"0.4rem 0.8rem", fontSize:"0.94rem", fontWeight:600, cursor:"pointer" }}>
                  Cerrar todo
                </button>
              </div>
            </div>
            {liquidacion.length === 0 ? (
              <p style={{ color:"#9ca3af", textAlign:"center", margin:0, fontSize:"1.02rem" }}>
                No hay niveles con recaudo o proyección en los datos cargados.
              </p>
            ) : (
            <div style={cajaTabla}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"0.94rem" }}>
                <thead><tr>
                  <th style={thH}>CCPET</th>
                  <th style={{ ...thH, minWidth:"260px" }}>NOMBRE</th>
                  <th style={{ ...thH, textAlign:"right", background:"#1e40af" }}>Rec. {anios[anios.length-1]} (último cargado)</th>
                  <th style={{ ...thH, textAlign:"right", background:"#15803d" }}>Proyección {yr}</th>
                  <th style={{ ...thH, textAlign:"right" }}>Var. %</th>
                </tr></thead>
                <tbody>
                  {liqVisibles.map((liq, i) => {
                    const nivel = liq.nivel;
                    const indent = nivel * 14;
                    const peso = nivel === 0 ? 800 : nivel <= 1 ? 700 : nivel <= 3 ? 600 : 400;
                    const bgRow = nivel === 0 ? "#1e3a8a" : nivel === 1 ? "#1e40af" :
                                  nivel === 2 ? "#2563eb" : nivel === 3 ? "#dbeafe" :
                                  i % 2 === 0 ? "#f0f6ff" : "#fff";
                    const clr = nivel <= 2 ? "#fff" : "#111827";
                    const hijos = liqTieneHijos(liq.ccpet);
                    const abierto = liqAbierto(liq.ccpet);
                    const vari = liq.ult > 0 ? Math.round((liq.proy / liq.ult - 1) * 1000) / 10 : null;
                    return (
                      <tr key={liq.ccpet}>
                        <td style={{ padding:"0.45rem 0.65rem", background:bgRow,
                          borderBottom:"1px solid #e5e7eb", fontFamily:"monospace", whiteSpace:"nowrap",
                          fontSize:"0.86rem", color:nivel<=2?"#bfdbfe":nivel<=3?"#1e40af":"#374151", fontWeight:peso }}>
                          <span style={{ display:"inline-flex", alignItems:"center", gap:"0.3rem" }}>
                            {hijos ? (
                              <button type="button"
                                onClick={() => setExpLiq(p => ({ ...p, [liq.ccpet]: !abierto }))}
                                style={{ border:"none", background:"transparent", cursor:"pointer", padding:0,
                                  display:"flex", alignItems:"center", color:"inherit" }}>
                                {abierto ? <ChevronDown size={13}/> : <ChevronRight size={13}/>}
                              </button>
                            ) : <span style={{ width:13, display:"inline-block" }}/>}
                            {liq.ccpet}
                          </span>
                        </td>
                        <td style={{ padding:`0.45rem 0.65rem 0.45rem ${indent+8}px`,
                          background:bgRow, borderBottom:"1px solid #e5e7eb",
                          fontSize:"0.9rem", fontWeight:peso, color:clr, maxWidth:"320px" }}>
                          {liq.nombre}
                        </td>
                        <td style={{ padding:"0.45rem 0.65rem", background: nivel<=2?"#1e3a8a":"#dbeafe",
                          borderBottom:"1px solid #e5e7eb", textAlign:"right",
                          fontFamily:"monospace", fontSize:"0.89rem",
                          fontWeight:peso, color: nivel<=2?"#bfdbfe":"#1e40af" }}>
                          {liq.ult > 0 ? fCOP(liq.ult) : "—"}
                        </td>
                        <td style={{ padding:"0.45rem 0.65rem", background: nivel<=2?"#065f46":"#dcfce7",
                          borderBottom:"1px solid #e5e7eb", textAlign:"right",
                          fontFamily:"monospace", fontSize:"0.91rem",
                          fontWeight:700, color: nivel<=2?"#a7f3d0":"#065f46" }}>
                          {liq.proy > 0 ? fCOP(liq.proy) : "—"}
                        </td>
                        <td style={{ padding:"0.45rem 0.65rem", background:"#fff",
                          borderBottom:"1px solid #e5e7eb", textAlign:"right", fontSize:"0.89rem" }}>
                          {fPct(vari)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot><tr style={{ background:"#163b8c" }}>
                  <td colSpan={2} style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.55rem 0.65rem", color:"#fff", fontWeight:800, fontSize:"0.96rem" }}>
                    TOTAL INGRESOS
                  </td>
                  <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.55rem 0.65rem", textAlign:"right", color:"#fff",
                    fontWeight:800, fontFamily:"monospace", fontSize:"0.96rem" }}>{fCOP(liqTotUlt)}</td>
                  <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.55rem 0.65rem", textAlign:"right", color:"#fff",
                    fontWeight:800, fontFamily:"monospace", fontSize:"0.98rem" }}>{fCOP(liqTotProy)}</td>
                  <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.55rem 0.65rem", textAlign:"right", color:"#fff", fontSize:"0.94rem", fontWeight:700 }}>
                    {liqTotUlt > 0 ? `${Math.round((liqTotProy / liqTotUlt - 1) * 1000) / 10}%` : "—"}
                  </td>
                </tr></tfoot>
              </table>
            </div>
            )}
          </Bloque>

          {/* ── Métodos de cálculo (agrupados) ── */}
          <Bloque id="sec-metodos" titulo="Métodos de cálculo"
            badge="5 métodos"
            sub="Ver cada método individualmente"
            open={open.metodos} onToggle={() => setOpen(p=>({...p,metodos:!p.metodos}))}>

            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
              flexWrap:"wrap", gap:"0.75rem", marginBottom:"1rem" }}>
              <p style={{ fontSize:"0.96rem", color:"#6b7280", margin:0, maxWidth:"640px" }}>
                La inflación, el ajuste general y los % por rubro se guardan solos en el sistema;
                también puedes usar <strong>Guardar</strong>.
              </p>
              {botonGuardar()}
            </div>

            {/* Sub-tarjeta interna */}
            {[
              { key:"a", titulo:"Método a — Automático",
                sub:`Último recaudo × (1 + inflación%). Proyección ${yr}`,
                param: pInp(inf, e=>setInf(parseFloat(e.target.value)||0), "Inflación:"),
                mkey:"auto" },
              { key:"b", titulo:"Método b — Promedios",
                sub:`Media aritmética de las ${anios.length} vigencias. Proyección ${yr}`,
                param: null, mkey:"prom" },
              { key:"c", titulo:"Método c — Mixto / Aumentos",
                sub:`Último recaudo × (1 ± % ajuste). Ajuste general o un % propio por rubro. Proyección ${yr}`,
                param: pInp(mix, e=>setMix(parseFloat(e.target.value)||0), "% ajuste:"),
                mkey:"mixt" },
              { key:"d", titulo:"Método d — Estadístico / Mínimos Cuadrados",
                sub:`Regresión lineal Y = a + bx. Proyección ${yr}`,
                param: null, mkey:"mc" },
              { key:"e", titulo:"Método e — Incremento Porcentual Promedio",
                sub:`Tc × (1 + tasa prom. interanual). Proyección ${yr}`,
                param: null, mkey:"inc" },
            ].map(m => (
              <div key={m.key} id={`met-${m.key}`} style={{ border:"1px solid #e5e7eb", borderRadius:"12px",
                marginBottom:"0.75rem", overflow:"clip", scrollMarginTop: 140 }}>
                <div onClick={()=>togM(m.key)}
                  style={{ padding:"0.9rem 1.25rem", cursor:"pointer",
                    background: openMetodo[m.key]?"#f0f6ff":"#fafafa",
                    borderBottom: openMetodo[m.key]?"1px solid #dbeafe":"none",
                    display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <span style={{ fontWeight:700, color:"#163b8c", fontSize:"1.08rem" }}>{m.titulo}</span>
                    {m.sub && <span style={{ marginLeft:"0.75rem", fontSize:"0.94rem", color:"#6b7280" }}>{m.sub}</span>}
                    {m.param && <div style={{ marginTop:"0.3rem" }} onClick={e=>e.stopPropagation()}>{m.param}</div>}
                  </div>
                  <span style={{ color:"#163b8c", display:"flex", alignItems:"center", gap:"0.3rem",
                    fontSize:"0.98rem", fontWeight:600, flexShrink:0, marginLeft:"1rem" }}>
                    {openMetodo[m.key]?<><ChevronDown size={14}/>Ocultar</>:<><ChevronRight size={14}/>Ver</>}
                  </span>
                </div>
                {openMetodo[m.key] && (
                  <div style={{ padding:"1rem 1.25rem" }}>
                    <TMetodo items={caps} mkey={m.mkey}
                      q={qMet[m.mkey] ?? ""} setQ={v => setQMet(p => ({ ...p, [m.mkey]: v }))}
                      ajuste={m.mkey === "mixt" ? {
                        general: mix,
                        valorDe: it => mixRubro[it._rk] ?? "",
                        setPct: setMixDe,
                        limpiar: it => setMixDe(it, ""),
                        limpiarTodos: () => guardarMixRubro(() => ({})),
                      } : undefined}/>
                    <div style={{ display:"flex", justifyContent:"center", marginTop:"0.9rem" }}>
                      <button type="button" onClick={() => togM(m.key)}
                        style={{ border:"1px solid #e5e7eb", background:"#fafafa", color:"#163b8c", borderRadius:"999px",
                          padding:"0.35rem 0.95rem", fontWeight:700, fontSize:"0.91rem", cursor:"pointer" }}>
                        ▲ Cerrar {m.titulo.split(" — ")[0]}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </Bloque>

          {/* ── Fondos especiales ── */}
          <Bloque id="sec-fondos" titulo="Fondos Especiales"
            badge="5 fondos + sin asignar"
            sub="Proyección clasificada por fondo-sección"
            open={open.fondos} onToggle={() => setOpen(p=>({...p,fondos:!p.fondos}))}>

            {FONDOS_CONFIG.map(f => {
              // Capturas que pertenecen a este fondo
              const capsFondo = caps.filter(c => fondoDe(c) === f.id);
              const totalFondo = capsFondo.reduce((s, c) => s + getV(c), 0);

              // Agregados cuyos hijos pertenecen a este fondo — calcular valor sumando solo hijos del fondo
              const getVFondo = (agg) => {
                const hijosEnFondo = hijosDe(agg.ccpet).filter(c =>
                  fondoDe(c) === f.id
                );
                return Math.round(hijosEnFondo.reduce((s, c) => {
                  const m = mets[c._rk] ?? "auto";
                  return s + (m === "prop" ? (parseFloat(propios[c._rk]?.valor)||0) : (Number(c._m?.[m])||0));
                }, 0));
              };
              const aggsFondo = aggs.filter(agg => getVFondo(agg) > 0);

              // Combinar y ordenar: agregados + capturas mezclados por CCPET
              const todasFondo = [...aggsFondo.map(a=>({...a,_esFondo:false})),
                                  ...capsFondo.map(c=>({...c,_esFondo:true}))
                ].sort((a,b)=>{
                  const pa=a.ccpet.split('.').map(Number), pb=b.ccpet.split('.').map(Number);
                  for(let i=0;i<Math.max(pa.length,pb.length);i++){
                    const d=(pa[i]??0)-(pb[i]??0); if(d) return d;
                  }
                  return a.es_captura?1:-1;
                });

              // Descarga CSV del fondo
              const descargarFondo = () => {
                const bom = "\uFEFF";
                const esFLS = f.id === "FLS";
                const cab = ["CCPET","NOMBRE","C.RES","TIPO", ...(esFLS ? ["SUBCUENTA"] : []),"MÉTODO","VALOR PROYECTADO"].join(";");
                const rows = todasFondo.map(it => [
                  it.ccpet,
                  `"${it.nombre}"`,
                  it.cres ?? "",
                  it.es_captura ? "Captura" : "Agregado",
                  ...(esFLS ? [it.es_captura ? `"${SUBCUENTAS_FLS.find(x => x.id === subcuentaFLS(it))?.titulo}"` : ""] : []),
                  it.es_captura ? (ML[getM(it)] ?? getM(it)) : "Sumatoria",
                  String(Math.round(it.es_captura ? getV(it) : getVFondo(it))).replace(".",","),
                ].join(";"));
                const blob = new Blob([bom+cab+"\n"+rows.join("\n")],{type:"text/csv;charset=utf-8;"});
                const a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = `Fondo_${f.titulo}_${yr}.csv`;
                a.click();
                URL.revokeObjectURL(a.href);
              };

              const thF = { ...fijoArriba, padding:"0.5rem 0.65rem", background:"#163b8c", color:"#fff",
                fontWeight:700, textAlign:"left", whiteSpace:"nowrap", fontSize:"0.86rem" };

              return (
                <div key={f.key} id={`fondo-${f.key}`} style={{ scrollMarginTop: 140, border:"1px solid #e5e7eb", borderRadius:"12px",
                  marginBottom:"0.75rem", overflow:"hidden" }}>

                  {/* Cabecera */}
                  <div onClick={()=>togF(f.key)}
                    style={{ padding:"0.9rem 1.25rem", cursor:"pointer",
                      background: openFondo[f.key] ? "#eff6ff" : "#fafafa",
                      borderBottom: openFondo[f.key] ? "1px solid #dbeafe" : "none",
                      display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:"0.75rem", flexWrap:"wrap" }}>
                      <span style={{ fontWeight:800, color:"#163b8c", fontSize:"1.14rem" }}>{f.titulo}</span>
                      <span style={{ fontSize:"0.94rem", color:"#6b7280" }}>{f.desc}</span>
                      <span style={{ background:"#e5e7eb", color:"#374151", borderRadius:"999px",
                        padding:"0.15rem 0.7rem", fontSize:"0.85rem", fontWeight:700 }}>
                        {capsFondo.length} capturas · {aggsFondo.length} agregados
                      </span>
                      <span style={{ background:"#163b8c", color:"#fff", borderRadius:"999px",
                        padding:"0.15rem 0.8rem", fontSize:"0.85rem", fontWeight:700 }}>
                        {fCOP(totalFondo)}
                      </span>
                    </div>
                    <span style={{ color:"#163b8c", display:"flex", alignItems:"center", gap:"0.3rem",
                      fontSize:"0.98rem", fontWeight:600, flexShrink:0, marginLeft:"1rem" }}>
                      {openFondo[f.key]?<><ChevronDown size={14}/>Ocultar</>:<><ChevronRight size={14}/>Ver</>}
                    </span>
                  </div>

                  {/* Contenido */}
                  {openFondo[f.key] && (
                    <div style={{ padding:"1rem 1.25rem" }}>
                      {capsFondo.length === 0 ? (
                        <p style={{ color:"#9ca3af", textAlign:"center", margin:0, fontSize:"1.02rem" }}>
                          No hay cuentas de este fondo en los datos cargados.
                        </p>
                      ) : (<>
                        {f.id === "FLS" && (() => {
                          const grupos = SUBCUENTAS_FLS.map(sc => {
                            const capsSc = capsFondo.filter(c => subcuentaFLS(c) === sc.id);
                            return { ...sc, n: capsSc.length, ...presupuestoDe(capsSc) };
                          }).filter(g => g.id !== "SIN" || g.n > 0);
                          const totalSub = grupos.reduce((s, g) => s + g.total, 0);
                          const bloque = g => ({ titulo: g.titulo, filas: g.filas, total: g.total });
                          const tdS = { padding:"0.55rem 0.75rem", borderBottom:"1px solid #e5e7eb", verticalAlign:"middle" };
                          return (
                            <div style={{ marginBottom:"1.5rem" }}>
                              {/* Resumen por subcuenta */}
                              <div style={{ border:"1px solid #ddd6fe", borderRadius:"12px", marginBottom:"1rem", overflow:"clip" }}>
                                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap",
                                  gap:"0.75rem", padding:"0.75rem 1rem", background:"#f5f3ff", borderBottom:"1px solid #ddd6fe" }}>
                                  <div>
                                    <div style={{ fontWeight:800, color:"#5b21b6", fontSize:"1.1rem" }}>Subcuentas del Fondo Local de Salud</div>
                                    <div style={{ fontSize:"0.9rem", color:"#6b7280" }}>
                                      Cada subcuenta es un mini presupuesto con estructura CCPET. Clic en una para abrir su detalle.
                                    </div>
                                  </div>
                                  <button type="button"
                                    onClick={() => descargarPresupuestos(grupos.map(bloque), totalSub, `TOTAL FONDO LOCAL DE SALUD ${yr}`, `FLS_subcuentas_${yr}.csv`)}
                                    style={{ display:"flex", alignItems:"center", gap:"0.5rem", background:"#5b21b6", color:"#fff",
                                      border:"none", borderRadius:"8px", padding:"0.5rem 1rem", fontWeight:700, fontSize:"0.98rem", cursor:"pointer" }}>
                                    <Download size={14}/> Descargar todas las subcuentas {yr}
                                  </button>
                                </div>
                                <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"1rem" }}>
                                  <thead><tr>
                                    <th style={{ ...thF, position:"static", background:"#5b21b6" }}>SUBCUENTA</th>
                                    <th style={{ ...thF, position:"static", background:"#5b21b6", textAlign:"center" }}>RUBROS</th>
                                    <th style={{ ...thF, position:"static", background:"#15803d", textAlign:"right" }}>VALOR PROYECTADO {yr}</th>
                                    <th style={{ ...thF, position:"static", background:"#5b21b6", textAlign:"right" }}>% DEL FLS</th>
                                  </tr></thead>
                                  <tbody>
                                    {grupos.map((g, i) => {
                                      const bg = i % 2 === 0 ? "#faf5ff" : "#fff";
                                      return (
                                        <tr key={g.id} style={{ cursor:"pointer" }} title="Ir al detalle de la subcuenta"
                                          onClick={() => { setAbiertasSub(p => ({ ...p, [g.id]: true }));
                                            requestAnimationFrame(() => document.getElementById(`sub-${g.id}`)?.scrollIntoView({ block:"start", behavior:"smooth" })); }}>
                                          <td style={{ ...tdS, background:bg, fontWeight:700, color:g.color }}>{g.titulo}</td>
                                          <td style={{ ...tdS, background:bg, textAlign:"center", color:"#6b7280" }}>{g.n}</td>
                                          <td style={{ ...tdS, background: i % 2 === 0 ? "#dcfce7" : "#bbf7d0", textAlign:"right",
                                            fontFamily:"monospace", fontWeight:800, color:"#065f46" }}>{fCOP(g.total)}</td>
                                          <td style={{ ...tdS, background:bg, textAlign:"right" }}>
                                            {totalSub ? `${(g.total / totalSub * 100).toFixed(2).replace(".", ",")}%` : "—"}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                  <tfoot><tr>
                                    <td style={{ padding:"0.55rem 0.75rem", background:"#5b21b6", color:"#fff", fontWeight:800 }}>TOTAL FONDO LOCAL DE SALUD</td>
                                    <td style={{ padding:"0.55rem 0.75rem", background:"#5b21b6", color:"#fff", textAlign:"center", fontWeight:700 }}>
                                      {grupos.reduce((s, g) => s + g.n, 0)}
                                    </td>
                                    <td style={{ padding:"0.55rem 0.75rem", background:"#5b21b6", color:"#fff", textAlign:"right",
                                      fontFamily:"monospace", fontWeight:800 }}>{fCOP(totalSub)}</td>
                                    <td style={{ padding:"0.55rem 0.75rem", background:"#5b21b6", color:"#fff", textAlign:"right", fontWeight:700 }}>100%</td>
                                  </tr></tfoot>
                                </table>
                              </div>

                              {/* Un mini presupuesto por subcuenta, con la misma estructura del fondo */}
                              {grupos.map(g => {
                                const ab = !!abiertasSub[g.id];
                                const alternar = () => { setAbiertasSub(p => ({ ...p, [g.id]: !p[g.id] })); if (ab) volverA(`sub-${g.id}`, 140); };
                                return (
                                  <div key={g.id} id={`sub-${g.id}`} style={{ scrollMarginTop:140, border:`1px solid ${g.color}55`,
                                    borderLeft:`5px solid ${g.color}`, borderRadius:"10px", marginBottom:"0.75rem", overflow:"clip" }}>
                                    <div onClick={alternar} style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
                                      gap:"0.75rem", flexWrap:"wrap", padding:"0.75rem 1rem", cursor:"pointer",
                                      background: ab ? "#f8f7ff" : "#fff", borderBottom: ab ? "1px solid #e5e7eb" : "none" }}>
                                      <div style={{ display:"flex", alignItems:"center", gap:"0.75rem", flexWrap:"wrap" }}>
                                        <span style={{ fontWeight:800, color:g.color, fontSize:"1.08rem" }}>{g.titulo}</span>
                                        <span style={{ background:"#e5e7eb", color:"#374151", borderRadius:"999px", padding:"0.15rem 0.7rem",
                                          fontSize:"0.85rem", fontWeight:700 }}>{g.n} capturas · {g.filas.length - g.n} agregados</span>
                                        <span style={{ background:g.color, color:"#fff", borderRadius:"999px", padding:"0.15rem 0.8rem",
                                          fontSize:"0.85rem", fontWeight:700 }}>{fCOP(g.total)}</span>
                                      </div>
                                      <span style={{ color:g.color, display:"flex", alignItems:"center", gap:"0.3rem", fontWeight:600, fontSize:"0.98rem" }}>
                                        {ab ? <><ChevronDown size={14}/>Ocultar</> : <><ChevronRight size={14}/>Ver</>}
                                      </span>
                                    </div>
                                    {ab && (
                                      <div style={{ padding:"0.9rem 1rem" }}>
                                        <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:"0.75rem" }}>
                                          <button type="button"
                                            onClick={() => descargarPresupuestos([bloque(g)], g.total, "", `FLS_${g.id}_${yr}.csv`)}
                                            style={{ display:"flex", alignItems:"center", gap:"0.5rem", background:g.color, color:"#fff",
                                              border:"none", borderRadius:"8px", padding:"0.5rem 1rem", fontWeight:700, fontSize:"0.98rem", cursor:"pointer" }}>
                                            <Download size={14}/> Descargar {g.titulo} {yr}
                                          </button>
                                        </div>
                                        <div style={cajaTabla}>
                                          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"0.9rem" }}>
                                            <thead><tr>
                                              <th style={thF}>CCPET</th>
                                              <th style={thF}>C.RES</th>
                                              <th style={{ ...thF, minWidth:"220px" }}>NOMBRE</th>
                                              <th style={thF}>TIPO</th>
                                              <th style={thF}>MÉTODO</th>
                                              <th style={{ ...thF, textAlign:"right", background:"#15803d", minWidth:"140px" }}>Valor proyectado {yr}</th>
                                            </tr></thead>
                                            <tbody>
                                              {g.filas.map((it, i) => {
                                                const esAgg = it.esAgg;
                                                const bgRow = esAgg ? (i%2===0?"#dbeafe":"#bfdbfe") : (i%2===0?"#f9fafb":"#fff");
                                                const ctRow = esAgg ? "#1e3a8a" : "#111827";
                                                const fwRow = esAgg ? 700 : 400;
                                                const indent = esAgg ? (it.ccpet.match(/\./g)||[]).length * 10 : 0;
                                                return (
                                                  <tr key={it._rk} style={{ borderBottom:"1px solid #e5e7eb" }}>
                                                    <td style={{ padding:"0.4rem 0.65rem", background:bgRow, color:ctRow, fontWeight:fwRow }}>
                                                      <code style={{ fontSize:"0.8rem", color: esAgg?"#1e40af":"#374151" }}>{it.ccpet}</code>
                                                    </td>
                                                    <td style={{ padding:"0.4rem 0.65rem", background:bgRow, fontSize:"0.84rem", color:"#6b7280" }}>{it.cres ?? ""}</td>
                                                    <td style={{ padding:`0.4rem 0.65rem 0.4rem ${indent+6}px`, background:bgRow, color:ctRow, fontWeight:fwRow, maxWidth:"280px" }}>
                                                      {it.nombre}
                                                    </td>
                                                    <td style={{ padding:"0.4rem 0.65rem", background:bgRow, fontSize:"0.84rem", color:"#6b7280" }}>
                                                      {esAgg ? "Agregado" : "Captura"}
                                                    </td>
                                                    <td style={{ padding:"0.4rem 0.65rem", background:bgRow, fontSize:"0.84rem", color:"#163b8c", fontWeight:600 }}>
                                                      {esAgg ? "Sumatoria" : it.met}
                                                    </td>
                                                    <td style={{ padding:"0.4rem 0.65rem", textAlign:"right", fontFamily:"monospace", fontWeight: esAgg?800:700,
                                                      background: i%2===0?"#dcfce7":"#bbf7d0", color:"#065f46" }}>{fCOP(it.val)}</td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                            <tfoot><tr>
                                              <td colSpan={5} style={{ position:"sticky", bottom:0, zIndex:3, background:g.color, padding:"0.55rem 0.65rem",
                                                color:"#fff", fontWeight:700, fontSize:"0.94rem" }}>TOTAL {g.titulo.toUpperCase()}</td>
                                              <td style={{ position:"sticky", bottom:0, zIndex:3, background:g.color, padding:"0.55rem 0.65rem", textAlign:"right",
                                                color:"#fff", fontWeight:800, fontFamily:"monospace", fontSize:"0.98rem" }}>{fCOP(g.total)}</td>
                                            </tr></tfoot>
                                          </table>
                                        </div>
                                        <div style={{ display:"flex", justifyContent:"center", marginTop:"0.75rem" }}>
                                          <button type="button" onClick={alternar}
                                            style={{ border:"1px solid #e5e7eb", background:"#fafafa", color:g.color, borderRadius:"999px",
                                              padding:"0.35rem 0.95rem", fontWeight:700, fontSize:"0.91rem", cursor:"pointer" }}>
                                            ▲ Cerrar {g.titulo}
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}

                              <div style={{ fontWeight:800, color:"#163b8c", fontSize:"1.05rem", margin:"1.25rem 0 0.5rem" }}>
                                FLS consolidado (todas las subcuentas)
                              </div>
                            </div>
                          );
                        })()}

                        {/* Botón descarga */}
                        <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:"0.75rem" }}>
                          <button type="button" onClick={descargarFondo}
                            style={{ display:"flex", alignItems:"center", gap:"0.5rem",
                              background:"#163b8c", color:"#fff", border:"none", borderRadius:"8px",
                              padding:"0.5rem 1rem", fontWeight:700, fontSize:"0.98rem", cursor:"pointer" }}>
                            <Download size={14}/> Descargar {f.titulo} {yr}
                          </button>
                        </div>

                        <div style={cajaTabla}>
                          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"0.9rem" }}>
                            <thead><tr>
                              <th style={thF}>CCPET</th>
                              <th style={thF}>C.RES</th>
                              <th style={{ ...thF, minWidth:"220px" }}>NOMBRE</th>
                              <th style={thF}>TIPO</th>
                              <th style={thF}>MÉTODO</th>
                              <th style={{ ...thF, textAlign:"right", background:"#15803d", minWidth:"140px" }}>
                                Valor proyectado {yr}
                              </th>
                            </tr></thead>
                            <tbody>
                              {todasFondo.map((it, i) => {
                                const esAgg = !it.es_captura;
                                const valIt = esAgg ? getVFondo(it) : getV(it);
                                const bgRow = esAgg
                                  ? (i%2===0?"#dbeafe":"#bfdbfe")
                                  : (i%2===0?"#f9fafb":"#fff");
                                const ctRow = esAgg ? "#1e3a8a" : "#111827";
                                const fwRow = esAgg ? 700 : 400;
                                const nivel = (it.ccpet.match(/\./g)||[]).length;
                                const indent = esAgg ? nivel * 10 : 0;
                                return (
                                  <tr key={it._rk} style={{ borderBottom:"1px solid #e5e7eb" }}>
                                    <td style={{ padding:"0.4rem 0.65rem", background:bgRow, color:ctRow, fontWeight:fwRow }}>
                                      <code style={{ fontSize:"0.8rem", color: esAgg?"#1e40af":"#374151" }}>{it.ccpet}</code>
                                    </td>
                                    <td style={{ padding:"0.4rem 0.65rem", background:bgRow,
                                      fontSize:"0.84rem", color:"#6b7280" }}>
                                      {it.cres ?? ""}
                                    </td>
                                    <td style={{ padding:`0.4rem 0.65rem 0.4rem ${indent+6}px`,
                                      background:bgRow, color:ctRow, fontWeight:fwRow, maxWidth:"280px" }}>
                                      {it.nombre}
                                    </td>
                                    <td style={{ padding:"0.4rem 0.65rem", background:bgRow,
                                      fontSize:"0.84rem", color:"#6b7280" }}>
                                      {esAgg ? "Agregado" : "Captura"}
                                    </td>
                                    <td style={{ padding:"0.4rem 0.65rem", background:bgRow,
                                      fontSize:"0.84rem", color:"#163b8c", fontWeight:600 }}>
                                      {esAgg ? "Sumatoria" : (ML[getM(it)] ?? getM(it))}
                                    </td>
                                    <td style={{ padding:"0.4rem 0.65rem", textAlign:"right",
                                      fontFamily:"monospace", fontWeight: esAgg?800:700,
                                      background: i%2===0?"#dcfce7":"#bbf7d0", color:"#065f46" }}>
                                      {fCOP(valIt)}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tfoot><tr style={{ background:"#163b8c" }}>
                              <td colSpan={5} style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.55rem 0.65rem",
                                color:"#fff", fontWeight:700, fontSize:"0.94rem" }}>
                                TOTAL {f.titulo}
                              </td>
                              <td style={{ position:"sticky", bottom:0, zIndex:3, background:"#163b8c", padding:"0.55rem 0.65rem", textAlign:"right",
                                color:"#fff", fontWeight:800, fontFamily:"monospace", fontSize:"0.98rem" }}>
                                {fCOP(totalFondo)}
                              </td>
                            </tr></tfoot>
                          </table>
                        </div>
                      </>)}
                      <div style={{ display:"flex", justifyContent:"center", marginTop:"0.9rem" }}>
                        <button type="button" onClick={() => togF(f.key)}
                          style={{ border:"1px solid #e5e7eb", background:"#fafafa", color:"#163b8c", borderRadius:"999px",
                            padding:"0.35rem 0.95rem", fontWeight:700, fontSize:"0.91rem", cursor:"pointer" }}>
                          ▲ Cerrar {f.titulo}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </Bloque>

        </>)}

        {loading && <div style={{ textAlign:"center", color:"#6b7280", padding:"3rem" }}>Cargando datos...</div>}
        {!loading && caps.length === 0 && (datos?.vigencias ?? []).length === 0 && (
          <div style={{ background:"#fff", borderRadius:"16px", border:"1px solid #e5e7eb",
            padding:"3rem", textAlign:"center", color:"#6b7280" }}>
            Carga al menos una vigencia histórica para comenzar.
          </div>
        )}

      </div>
    </div>
  );
}